import {Permission} from '../services/PermissionService';
import {APP, IN_NETWORK_COLOR} from './../../../web/src/style/variable';

export const USER = {
  ADMIN: 'admin'
};

export const USER_TYPE = {
  ADMIN: 'admin',
  USER: 'user'
};

// PAYMENT PROVIDER DETAILS
// NOTE: If any payment method is added or removed, remove it from all these three
export const PAYMENT_METHOD = [
  {label: 'INSTAMED', value: 'INSTAMED'},
  {label: 'OPEN EDGE', value: 'OPEN EDGE'}
];

export const NUMBER_TYPE = [
  {label: 'Clinical', value: 'clinical'},
  {label: 'Billing', value: 'billing'},
  {label: 'Voice Assistant', value: 'Voice Assistant'}
];

export const VOICE_ASSISTANT_LANGUAGES = [
  {label: 'English', value: 'English'},
  {label: 'Spanish', value: 'Spanish'}
];

export const PAYMENT_METHODS = {
  INSTAMED: 'INSTAMED',
  OPENEDGE: 'OPEN EDGE'
};
export type PAYMENT_TYPES_ENUM = 'INSTAMED' | 'OPEN EDGE';

// Statuses
export const AppPaymentStatus = {
  IN_PROGRESS: 'in progress',
  PAID: 'paid',
  PARTIALLY_PAID: 'partially paid',
  FAILED: 'failed'
};
// PAYMENT PROVIDER END

// medops specific users types
export const UserTypes = {
  ADMIN: 'admin',
  USER: 'user'
};

// Statement Statuses
export const StatementStatus = {
  UN_PAID: 'Unpaid',
  PAID: 'Paid',
  PARTIALLY_PAID: 'Partially Paid',
  SETTLED: 'Settled'
};

export const ImportedStatementStatus = [
  {label: 'DUE_INVOICES.PREVIOUS_IMPORTED.UN_PAID', value: 'UN_PAID'},
  {label: 'DUE_INVOICES.PREVIOUS_IMPORTED.PAID', value: 'PAID'},
  {
    label: 'DUE_INVOICES.PREVIOUS_IMPORTED.PARTIALLY_PAID',
    value: 'PARTIALLY_PAID'
  },
  {label: 'DUE_INVOICES.PREVIOUS_IMPORTED.SETTLED', value: 'SETTLED'}
];

export const StatementNoticeType = {
  RD: {key: 'RD', label: 'Regular Due'},
  PD: {key: 'PD', label: 'Past Due'},
  FN: {key: 'FN', label: 'Final Notice'},
  STD: {key: 'STD', label: 'Settle the Statement'}
};

export const StatementNoticeTypeFilter = [
  {key: 'RD', label: 'Regular Due'},
  {key: 'PD', label: 'Past Due'},
  {key: 'FN', label: 'Final Notice'}
];

export const OtherChargeTypeFilter = [
  {key: 'patient copay payment', label: 'Copay'}
  // {key: 'statement adjustment', label: 'Statement Adjustment Payment'},
  // {key: 'past statement payment', label: 'Past Statement Payment'},
  // {key: 'immigration health check', label: 'Immigration Health Check'},
  // {key: 'other', label: 'Other Payment'}
];
export const AppSmsStatus = {
  PENDING: 'pending',
  SENT: 'sent',
  FAILED: 'failed',
  UNKNOWN: 'unknown',
  QUEUED: 'queued',
  IGNORED: 'ignored'
};

export const AppSmsStatusLabelMapper = {
  [AppSmsStatus.PENDING]: 'SMS_STATUSES.PENDING',
  [AppSmsStatus.SENT]: 'SMS_STATUSES.SENT',
  [AppSmsStatus.FAILED]: 'SMS_STATUSES.FAILED',
  [AppSmsStatus.UNKNOWN]: 'SMS_STATUSES.UNKNOWN',
  [AppSmsStatus.QUEUED]: 'SMS_STATUSES.QUEUED',
  [AppSmsStatus.IGNORED]: 'SMS_STATUSES.IGNORED'
};

export const ACTION_TYPES = {
  ACCESS_SHORT_LINK: {
    key: 'ACCESS_SHORT_LINK',
    label: 'ACTION_HISTORY.ACCESS_SHORT_LINK'
  },
  PAY_THROUGH_INSTAMED: {
    key: 'PAY_THROUGH_INSTAMED',
    label: 'ACTION_HISTORY.PAY_THROUGH_INSTAMED'
  },
  PAY_THROUGH_OPEN_EDGE: {
    key: 'PAY_THROUGH_OPEN_EDGE',
    label: 'ACTION_HISTORY.PAY_THROUGH_OPEN_EDGE'
  },
  PAY_THROUGH_INSTAMED_COMPLETED: {
    key: 'PAY_THROUGH_INSTAMED_COMPLETED',
    label: 'ACTION_HISTORY.PAY_THROUGH_INSTAMED_COMPLETED'
  },
  PAY_THROUGH_OPEN_EDGE_COMPLETED: {
    key: 'PAY_THROUGH_OPEN_EDGE_COMPLETED',
    label: 'ACTION_HISTORY.PAY_THROUGH_OPEN_EDGE_COMPLETED'
  },
  PAY_THROUGH_INSTAMED_FAILED: {
    key: 'PAY_THROUGH_INSTAMED_FAILED',
    label: 'ACTION_HISTORY.PAY_THROUGH_INSTAMED_FAILED'
  },
  PAY_THROUGH_OPEN_EDGE_FAILED: {
    key: 'PAY_THROUGH_OPEN_EDGE_FAILED',
    label: 'ACTION_HISTORY.PAY_THROUGH_OPEN_EDGE_FAILED'
  },
  GUARANTOR_LOGIN_SUCESS: {
    key: 'GUARANTOR_LOGIN_SUCESS',
    label: 'ACTION_HISTORY.GUARANTOR_LOGIN_SUCESS'
  },
  GUARANTOR_LOGIN_FAILED: {
    key: 'GUARANTOR_LOGIN_FAILED',
    label: 'ACTION_HISTORY.GUARANTOR_LOGIN_FAILED'
  },
  BILLING_USER_PAYMENT_INITIATED: {
    key: 'BILLING_USER_PAYMENT_INITIATED',
    label: 'ACTION_HISTORY.BILLING_USER_PAYMENT_INITIATED'
  },
  BILLING_USER_PAYMENT_COMPLETED: {
    key: 'BILLING_USER_PAYMENT_COMPLETED',
    label: 'ACTION_HISTORY.BILLING_USER_PAYMENT_COMPLETED'
  },
  BILLING_USER_PAYMENT_FAILED: {
    key: 'BILLING_USER_PAYMENT_FAILED',
    label: 'ACTION_HISTORY.BILLING_USER_PAYMENT_FAILED'
  },
  APPOINTMENT_PORTAL_ACCESS_SHORT_LINK: {
    key: 'APPOINTMENT_PORTAL_ACCESS_SHORT_LINK',
    label: 'ACTION_HISTORY.APPOINTMENT_PORTAL_ACCESS_SHORT_LINK'
  },
  APPOINTMENT_PORTAL_GUARANTOR_LOGIN_SUCCESS: {
    key: 'APPOINTMENT_PORTAL_GUARANTOR_LOGIN_SUCCESS',
    label: 'ACTION_HISTORY.APPOINTMENT_PORTAL_GUARANTOR_LOGIN_SUCCESS'
  },
  APPOINTMENT_PORTAL_GUARANTOR_LOGIN_FAILED: {
    key: 'APPOINTMENT_PORTAL_GUARANTOR_LOGIN_FAILED',
    label: 'ACTION_HISTORY.APPOINTMENT_PORTAL_GUARANTOR_LOGIN_FAILED'
  },
  APPOINTMENT_PORTAL_GUARANTOR_INSURANCE_UPLOAD_SUCCESS: {
    key: 'APPOINTMENT_PORTAL_GUARANTOR_INSURANCE_UPLOAD_SUCCESS',
    label:
      'ACTION_HISTORY.APPOINTMENT_PORTAL_GUARANTOR_INSURANCE_UPLOAD_SUCCESS'
  },
  APPOINTMENT_PORTAL_GUARANTOR_INSURANCE_UPLOAD_FAILED: {
    key: 'APPOINTMENT_PORTAL_GUARANTOR_INSURANCE_UPLOAD_FAILED',
    label: 'ACTION_HISTORY.APPOINTMENT_PORTAL_GUARANTOR_INSURANCE_UPLOAD_FAILED'
  },
  APPOINTMENT_PORTAL_GUARANTOR_SCHEDULE_APPOINTMENT_SUCCESS: {
    key: 'APPOINTMENT_PORTAL_GUARANTOR_SCHEDULE_APPOINTMENT_SUCCESS',
    label:
      'ACTION_HISTORY.APPOINTMENT_PORTAL_GUARANTOR_SCHEDULE_APPOINTMENT_SUCCESS'
  },
  APPOINTMENT_PORTAL_GUARANTOR_SCHEDULE_APPOINTMENT_FAILED: {
    key: 'APPOINTMENT_PORTAL_GUARANTOR_SCHEDULE_APPOINTMENT_FAILED',
    label:
      'ACTION_HISTORY.APPOINTMENT_PORTAL_GUARANTOR_SCHEDULE_APPOINTMENT_FAILED'
  },
  APPOINTMENT_PORTAL_GUARANTOR_DOWNLOAD_VACCINE_SUCCESS: {
    key: 'APPOINTMENT_PORTAL_GUARANTOR_DOWNLOAD_VACCINE_SUCCESS',
    label:
      'ACTION_HISTORY.APPOINTMENT_PORTAL_GUARANTOR_DOWNLOAD_VACCINE_SUCCESS'
  },
  APPOINTMENT_PORTAL_GUARANTOR_DOWNLOAD_VACCINE_FAILED: {
    key: 'APPOINTMENT_PORTAL_GUARANTOR_DOWNLOAD_VACCINE_FAILED',
    label: 'ACTION_HISTORY.APPOINTMENT_PORTAL_GUARANTOR_DOWNLOAD_VACCINE_FAILED'
  },
  SHARE_APPOINTMENT_LINK: {
    key: 'SHARE_APPOINTMENT_LINK',
    label: 'Shared Appointment Link'
  },
  SHARE_PAYMENT_LINK_BY_PRACTICE: {
    label: 'Shared Payment Link By Practice',
    key: 'SHARE_PAYMENT_LINK_BY_PRACTICE'
  },
  APPOINTMENT_REQUEST_REVIEW: {
    label: 'ACTION_HISTORY.APPOINTMENT_REQUEST_REVIEW',
    key: 'APPOINTMENT_REQUEST_REVIEW'
  },
  APPOINTMENT_PATIENT_REVIEW: {
    label: 'ACTION_HISTORY.APPOINTMENT_PATIENT_REVIEW',
    key: 'APPOINTMENT_PATIENT_REVIEW'
  }
};

export const ACTION_TYPE_KEYS = {
  SHARE_PAYMENT_LINK_BY_PRACTICE: 'SHARE_PAYMENT_LINK_BY_PRACTICE'
};

export const NotificationType = {
  SMS: 'sms',
  EMAIL: 'email'
};
export const PAYMENTS_TYPE_KEYS = {
  STATEMENT_PAYMENT_KEY: 'amount_paid',
  REFUNDS_PAYMENT_KEY: 'amount',
  COPAY_PAYMENT_KEY: 'charge_amount'
};

// delay in ms
export const SEARCH_DEBOUNCE_DELAY = 500;

// Objects and permissions
export const AppPermissions = {
  ADMIN: {
    NAME: 'Admin',
    LIST: 'List',
    CREATE: 'Create',
    EDIT: 'Edit',
    READ: 'Read',
    DELETE: 'Delete',
    ENABLE: 'Enable'
  },
  CLINIC_GROUP: {
    NAME: 'ClinicGroup',
    CREATE: 'Create',
    DELETE: 'Delete',
    EDIT: 'Edit',
    READ: 'Read',
    LIST: 'List'
  },
  CLINIC: {
    NAME: 'Clinic',
    CREATE: 'Create',
    DELETE: 'Delete',
    EDIT: 'Edit',
    ADVANCE_EDIT: 'Advance Edit',
    LIST: 'List',
    READ: 'Read',
    RECORD_INSURANCE_AMOUNT: 'Record Insurance Amount',
    ADD_WORK_TIMINGS: 'Add Work Timings',
    READ_WORK_TIMINGS: 'Read Work Timings',
    EDIT_WORK_TIMINGS: 'Edit Work Timings'
  },
  HOLIDAYS: {
    NAME: 'Holidays',
    CREATE: 'Create',
    DELETE: 'Delete',
    EDIT: 'Edit',
    READ: 'Read',
    LIST: 'List'
  },
  SERVICE_LOCATION: {
    NAME: 'ServiceLocation',
    CREATE: 'Create',
    DELETE: 'Delete',
    EDIT: 'Edit',
    READ: 'Read',
    LIST: 'List'
  },
  EMR_REQUEST_LOGS: {
    NAME: 'EMRRequestLogs',
    READ: 'Read',
    LIST: 'List'
  },
  DASHBOARD: {
    NAME: 'Dashboard',
    READ: 'Read'
  },
  USERS: {
    NAME: 'Users',
    READ: 'Read',
    DELETE: 'Delete',
    EDIT: 'Edit',
    LIST: 'List'
  },
  USER: {
    NAME: 'User',
    CREATE: 'Create',
    DELETE: 'Delete',
    DISABLE: 'Disable',
    EDIT: 'Edit',
    ENABLE: 'Enable',
    LIST: 'List',
    READ: 'Read',
    RESEND_INVITATION: 'Resend Invitation',
    UNLOCK_USER: 'Unlock The User'
  },
  CARD_MACHINES: {
    NAME: 'Card Machines'
  },
  PATIENT: {
    NAME: 'Patient',
    EDIT: 'Edit',
    DELETE: 'Delete',
    IMPORT: 'Import',
    LIST: 'List',
    READ: 'Read',
    EDIT_NOTIFICATION_PHONE: 'Edit Notification Phone',
    CREATE_PATIENT: 'Create Patient',
    CREATE_PATIENT_AND_PAY: 'Create Patient And Pay',
    PAY: 'Pay',
    ADD_COPAY: 'AddCopay',
    REMOVE_COPAY: 'RemoveCopay',
    SEND_REMINDER: 'Send Reminder',
    REMINDER_HISTORY: 'Reminder History',
    SETTLE_COPAY: 'SettleCopay',
    VIEW_DOB: 'View DOB',
    VIEW_SSN: 'View SSN'
  },
  STATEMENT: {
    NAME: 'Statement',
    IMPORT: 'Import',
    LIST: 'List',
    READ: 'Read',
    SEND_REMINDER: 'Send Reminder',
    IMPORT_FNPD: 'Import FN PD',
    UPDATE_FNPD: 'Update FN PD',
    EDIT_NOTIFICATION_PHONE: 'Edit Notification Phone',
    PAY: 'Pay',
    DOWNLOAD: 'Download',
    IMPORT_VOUCHER_META: 'Import Voucher Meta',
    SETTLE: 'Settle',
    CREATE: 'Create'
  },
  PAYMENT_HISTORY: {
    NAME: 'PaymentHistory',
    LIST: 'List',
    SEND_PAYMENT_RECIEPT: 'Send Payment Reciept',
    UPDATE_POSTING_STATUS: 'Update Posting Status',
    DOWNLOAD: 'Download',
    REFUND_AMOUNT: 'Refund Amount',
    SEND_REFUND_RECEIPT: 'Send Refund Receipt'
  },
  NOTIFICATION_HISTORY: {
    NAME: 'NotificationHistory',
    LIST: 'List',
    DOWNLOAD: 'Download'
  },
  ACTION_HISTORY: {
    NAME: 'ActionHistory',
    LIST: 'List'
  },
  PREVIOUS_IMPORTED_STATEMENTS: {
    NAME: 'ActionHistory',
    LIST: 'List'
  },
  INCOMING_SMS: {
    NAME: 'IncomingSms',
    LIST: 'List',
    READ: 'Read',
    REPLY: 'Reply',
    DELETE: 'Delete'
  },
  APPOINTMENT: {
    NAME: 'Appointment',
    LIST: 'List',
    READ: 'Read',
    CREATE: 'Create',
    EDIT: 'Edit',
    DELETE: 'Delete',
    SEND: 'Send',
    IMPORT: 'Import',
    SHOW_CLAIMS: 'ShowClaims',
    GOOD_VISIT: 'Good Visit',
    GATHER_FEEDBACK: 'Gather Feedback'
  },
  PATIENT_RECALL: {
    NAME: 'RecallAnalysis',
    LIST: 'List',
    SEND_REMINDER: 'SendReminder'
  },
  MENU_PERMISSIONS: {
    PATIENTS: 'patients',
    STATEMENTS: 'statements',
    APPOINTMENTS: 'appointments',
    PAYMENTS: 'payments',
    MESSAGES: 'messages',
    PATIENT_RECALL: 'patient_recalls',
    ELIGIBILITY_VERIFICATION: 'eligibility_verification',
    PRIOR_AUTHORIZATION_ENABLE: 'prior_authorizations_tickets',
    CLAIMS_TICKETS_ENABLE: 'claims_tickets',
    REFERRALS_TICKETS_ENABLE: 'referrals_tickets',
    PATIENT_PORTAL: 'patient_portal',
    CLAIMS_CPT_CODES_ENABLE: 'is_claim_tickets_cpt_codes_enabled',
    PHARMACY_CLAIMS_ENABLE: 'claims',
    ENABLE_ADD_PATIENTS: 'enable_add_patients',
    ENABLE_EDIT_PATIENTS: 'enable_edit_patients'
  },
  APPOINTMENT_HISTORY: {
    NAME: 'AppointmentHistory',
    DOWNLOAD: 'Download'
  },
  CARD_MACHINE: {
    NAME: 'CardMachine',
    LIST: 'List',
    READ: 'Read',
    EDIT: 'Edit',
    CREATE: 'Create',
    DELETE: 'Delete'
  },
  ELIGIBILITY_VERIFICATION: {
    NAME: 'EligibilityVerification',
    CREATE: 'Create',
    DELETE: 'Delete',
    EDIT: 'Edit',
    LIST: 'List',
    READ: 'Read'
  },
  REPORTS: {
    NAME: 'Reports',
    LIST: 'List',
    READ: 'Read',
    EDIT: 'Edit',
    CREATE: 'Create',
    DELETE: 'Delete'
  },
  CCM: {
    NAME: 'CCM',
    LIST: 'List',
    READ: 'Read',
    EDIT: 'Edit',
    CREATE: 'Create',
    DELETE: 'Delete',
    CREATE_PATIENT_PROBLEM_CONFIG: 'Create Patient Problem Config',
    EDIT_PATIENT_PROBLEM_CONFIG: 'Edit Patient Problem Config',
    LIST_PATIENT_PROBLEM_CONFIG: 'List Patient Problem Config',
    DELETE_PATIENT_PROBLEM_CONFIG: 'Delete Patient Problem Config'
  },
  CCM_MENU_PERMISSIONS: {
    CCM: 'ccm'
  },
  PATIENT_MENU_PERMISSIONS: {
    PATIENT_SHARED: 'patients_shared'
  },
  PAYMENT_PLAN: {
    NAME: 'PaymentPlan',
    CREATE: 'Create',
    CANCEL: 'Cancel',
    LIST: 'List',
    READ: 'Read',
    EDIT_CONFIG: 'EditConfig'
  },
  PATIENT_REVIEW: {
    NAME: 'PatientReview',
    LIST: 'List',
    READ: 'Read'
  },
  GROUP_PAYMENTS: {
    NAME: 'GroupPayments',
    CREATE: 'Create',
    DELETE: 'Delete',
    EDIT: 'Edit',
    LIST: 'List',
    READ: 'Read'
  },
  PRIOR_AUTHORIZATION: {
    NAME: 'PriorAuthorization',
    CREATE: 'Create',
    EDIT: 'Edit',
    READ: 'Read',
    LIST: 'List',
    DELETE: 'Delete',
    STATUS_LIST: 'Status List',
    CREATE_COMMENT: 'Create Comment',
    EDIT_COMMENT: 'Edit Comment',
    ACTION_HISTORY_LIST: 'List Action History',
    DELETE_COMMENT: 'Delete Comment',
    CREATE_ATTACHMENT: 'Create Attachment',
    READ_ATTACHMENT: 'Read Attachment',
    DELETE_ATTACHMENT: 'Delete Attachment',
    CREATE_WORK_LOG: 'Create Work Log',
    CREATE_WORK_LOG_MANUALLY: 'Create Work Log Manually',
    LIST_WORK_LOG: 'Work Logs List',
    DELETE_WORK_LOG: 'Delete Work Log',
    BULK_CREATE_PRIOR_AUTHS: 'Bulk Create Prior Authorizations',
    IMPORT_FILE: 'Import File',
    DASHBOARD: 'Dashboard',
    GENERATE_CODES: 'Generate Codes',
    REVIEW_CODES: 'Review Codes',
    IMPORT_VISIT_TYPE_CONFIG: 'Import Visit Type Config',
    CREATE_VISIT_TYPE_CONFIG: 'Create Visit Type Config',
    EDIT_VISIT_TYPE_CONFIG: 'Edit Visit Type Config',
    LIST_VISIT_TYPE_CONFIG: 'List Visit Type Config',
    DELETE_VISIT_TYPE_CONFIG: 'Delete Visit Type Config'
  } as const,
  CLAIMS_TICKETS: {
    NAME: 'ClaimTicket',
    CREATE: 'Create',
    EDIT: 'Edit',
    READ: 'Read',
    LIST: 'List',
    DELETE: 'Delete',
    STATUS_LIST: 'Status List',
    CREATE_COMMENT: 'Create Comment',
    EDIT_COMMENT: 'Edit Comment',
    ACTION_HISTORY_LIST: 'List Action History',
    DELETE_COMMENT: 'Delete Comment',
    CREATE_ATTACHMENT: 'Create Attachment',
    READ_ATTACHMENT: 'Read Attachment',
    DELETE_ATTACHMENT: 'Delete Attachment',
    CREATE_WORK_LOG: 'Create Work Log',
    CREATE_WORK_LOG_MANUALLY: 'Create Work Log Manually',
    LIST_WORK_LOG: 'Work Logs List',
    DELETE_WORK_LOG: 'Delete Work Log',
    BULK_CREATE_PRIOR_AUTHS: 'Bulk Create Prior Authorizations',
    IMPORT_FILE: 'Import File',
    DASHBOARD: 'Dashboard'
  } as const,
  REFERRALS_TICKETS: {
    NAME: 'ReferralTicket',
    CREATE: 'Create',
    EDIT: 'Edit',
    READ: 'Read',
    LIST: 'List',
    DELETE: 'Delete',
    STATUS_LIST: 'Status List',
    CREATE_COMMENT: 'Create Comment',
    EDIT_COMMENT: 'Edit Comment',
    ACTION_HISTORY_LIST: 'List Action History',
    DELETE_COMMENT: 'Delete Comment',
    CREATE_ATTACHMENT: 'Create Attachment',
    READ_ATTACHMENT: 'Read Attachment',
    DELETE_ATTACHMENT: 'Delete Attachment',
    CREATE_WORK_LOG: 'Create Work Log',
    CREATE_WORK_LOG_MANUALLY: 'Create Work Log Manually',
    LIST_WORK_LOG: 'Work Logs List',
    DELETE_WORK_LOG: 'Delete Work Log',
    DASHBOARD: 'Dashboard'
  } as const,
  SCHEDULED_JOBS: {
    NAME: 'ScheduledJobs',
    LIST: 'List'
  },
  MESSAGE_INBOX: {
    NAME: 'MessageInbox',
    CREATE: 'Create',
    CANCEL: 'Cancel',
    LIST: 'List',
    READ: 'Read',
    DELETE: 'Delete'
  },
  PATIENT_FORMS: {
    NAME: 'PatientForm',
    LIST: 'List',
    CREATE: 'Create',
    EDIT: 'Edit',
    READ: 'Read'
  },
  VACCINE: {
    NAME: 'Vaccine',
    CONFIG: 'Config'
  },
  // The below are the permissions for claims tickets
  CLAIMS: {
    NAME: 'Claims',
    LIST: 'List',
    CREATE: 'Create',
    EDIT: 'Edit',
    READ: 'Read'
  },
  // The below are the permissions for pharmacy claims
  CLAIM: {
    NAME: 'Claims',
    LIST: 'List',
    CREATE: 'Create',
    EDIT: 'Edit',
    READ: 'Read',
    SEND_CLAIM: 'Send Claim'
  },
  D0_CONFIGURATION: {
    NAME: 'D0 Configuration'
  },
  VOICE_ASSISTANT_CONFIG: {
    NAME: 'VoiceAssistantConfig',
    READ: 'Read',
    EDIT: 'Edit'
  },
  EMR_MAPPINGS_FILE: {
    NAME: 'EMR Mappings File'
  },
  EMR_SYNC: {
    NAME: 'EMR Sync',
    LIST: 'List',
    RESOLVE: 'Resolve',
    ADMIN: 'Admin'
  },
  SMART_CODER: {
    NAME: 'SmartCoder',
    LIST: 'List',
    CREATE: 'Create',
    EDIT: 'Edit',
    READ: 'Read',
    GENERATE_CODE: 'GenerateCode'
  }
};

export const CCMUserRole = {
  value: '8',
  label: 'CCM User'
};

export const VaccineSchedulerRole = {
  value: '9',
  label: 'Vaccine Scheduler'
};

export const PrioAuthTicketsUserRole = {
  value: '10',
  label: 'Prior Authorization Tickets User'
};

export const ClaimTicketsUserRole = {
  value: '11',
  label: 'Claim Tickets User'
};

export const PharmacyBillingUserRole = {
  value: '12',
  label: 'Pharmacy Billing User'
};

export const RPAUserRole = {
  value: '13',
  label: 'RPA User'
};

export const CoderRole = {
  value: '15',
  label: 'Coder'
};

export const ReferralTicketsUserRole = {
  value: '16',
  label: 'Referral Tickets User'
};

export const CCMAdminRole = {
  value: '17',
  label: 'CCM Admin'
};

export const UserRoles = [
  {
    value: '1',
    label: 'Practice Admin'
  },
  {
    value: '2',
    label: 'Basic'
  },
  {
    value: '3',
    label: 'Billing User'
  },
  {
    value: '4',
    label: 'Front Desk User'
  },
  {
    value: '7',
    label: 'Clinical User'
  },
  CCMUserRole,
  VaccineSchedulerRole,
  PrioAuthTicketsUserRole,
  ClaimTicketsUserRole,
  PharmacyBillingUserRole,
  RPAUserRole,
  CoderRole,
  ReferralTicketsUserRole,
  CCMAdminRole
];

export const NOTIFICATION_COUNT_FILTERS = [
  {
    label: 'DUE_INVOICES.NOTIFICATION_COUNT_FILTER.NO_NOTIFICATIONS_SENT',
    value: '0'
  },
  {
    label: 'DUE_INVOICES.NOTIFICATION_COUNT_FILTER.ONE_NOTIFICATION_SENT',
    value: '1'
  },
  {
    label:
      'DUE_INVOICES.NOTIFICATION_COUNT_FILTER.MORE_THAN_ONE_NOTIFICATION_SENT',
    value: '1+'
  }
];

export const ImportSummaryTypes = {
  PATIENT: 'patient',
  INVOICE: 'invoice',
  STATEMENT_TYPE: 'statement_type',
  PATIENT_COPAY: 'patient_copay'
};

export const PAYMENT_FLOW_FILTERS = [
  {
    label: 'PAYMENT_FLOW_FILTERS.NOTIFICATION_FAILED',
    value: 'notification failed'
  },
  {
    label: 'PAYMENT_FLOW_FILTERS.PAYMENT_LINK_NOT_OPENED',
    value: 'notification sent'
  },
  {
    label: 'PAYMENT_FLOW_FILTERS.PAYMENT_LINK_OPEN',
    value: 'payment link opened'
  },
  {
    label: 'PAYMENT_FLOW_FILTERS.LOGIN_FAILED',
    value: 'login failed'
  },
  {
    label: 'PAYMENT_FLOW_FILTERS.LOGIN_SUCCESS',
    value: 'login success'
  },
  {
    label: 'PAYMENT_FLOW_FILTERS.PAYMENT_INITIATED',
    value: 'payment initiated'
  },
  {
    label: 'PAYMENT_FLOW_FILTERS.PAYMENT_FAILED',
    value: 'payment failed'
  },
  {
    label: 'PAYMENT_FLOW_FILTERS.PAYMENT_SUCCESS',
    value: 'payment success'
  }
];

export const NOTIFICATION_BATCH_ID_LIMIT = 50;

export const PaymentTypes = {
  PUBLIC_AD_HOC_PATIENT_PAYMENT: 'public adhoc patient payment',
  AD_HOC_PATIENT_PAYMENT: 'adhoc patient payment',
  STATEMENT_PAYMENT: 'statement payment',
  AD_HOC_CLINIC_PAYMENT: 'adhoc clinic payment',
  PATIENT_COPAY_PAYMENT: 'patient copay payment',
  CONVENIENCE_FEE: 'convenience_fee',
  TOTAL_PAYMENT: 'total payment',
  STATEMENT_ADJUSTMENT: 'statement adjustment',
  PAST_STATEMENT_ADJUSTMENT: 'past statement payment',
  OTHER: 'other',
  OTHER_CHARGE_PAYMENTS: 'other charge payments',
  IMMIGRATION_HEALTH_CHECK: 'immigration health check',
  PAYMENT_PLAN: 'payment plans'
};
export const CCMConstants = {
  SPECIFY_CUSTOM_TASK: 'Specify Custom Task',
  STORAGE_CCM_PATIENT_LOG_ID: 'ccmPatientTimerLogId',
  STORAGE_CCM_TIMER_DATA: 'timerData',
  DATA_ENRTY: 'Data entry',
  INFORMATIONAL: 'Informational'
};

export const PriorAuthConstants = {
  STORAGE_PRIOR_AUTH_TIMER_DATA: 'PriorAuthTimerData'
};

export const PAYMENT_TYPES_LIST = [
  {
    label: 'PAYMENT_HISTORY.STATEMENT_PAYMENT',
    value: 'statement payment'
  },
  // {
  //   label: 'PAYMENT_HISTORY.AD_HOC_PATIENT_PAYMENT',
  //   value: 'adhoc patient payment'
  // },
  // {
  //   label: 'PAYMENT_HISTORY.PUBLIC_PAYMENTS',
  //   value: 'public adhoc patient payment'
  // },
  {
    label: 'PAYMENT_HISTORY.AD_HOC_CLINIC_PAYMENT',
    value: 'adhoc clinic payment',
    permissionFn: Permission.hasClinicPermissions,
    permissionAction: AppPermissions.CLINIC.RECORD_INSURANCE_AMOUNT
  },
  // {
  //   label: 'PAYMENT_HISTORY.PATIENT_COPAY_PAYMENT',
  //   // value: 'patient copay payment'
  // }
  {
    label: 'PAYMENT_HISTORY.COPAY_OTHER_TYPE_PAYMENTS',
    value: 'other charge payments'
  },
  {
    label: 'PAYMENT_PLANS.PAYMENT_PLAN_LABEL',
    value: 'payment plans',
    permissionFn: Permission.hasPaymentPlanPermissions,
    permissionAction: AppPermissions.PAYMENT_PLAN.LIST
  }
];

export const RECEIPT_TYPE = {
  PAYMENT: 'payment',
  REFUND: 'refund'
};

export const AMOUNT_TYPES = {
  AD_HOC_PATIENT: 'adhoc patient',
  STATEMENT: 'statement'
};

export const IMPORT_TYPES = {
  STATEMENTS: 'statements',
  PATIENTS: 'patients',
  FNPD: 'fnpd',
  PATIENT_COPAY: 'patient_copay',
  APPOINTMENTS: 'appointments',
  VOUCHER_NUMBER: 'voucher',
  CCM: 'ccm'
};

export const ReportsList: any = {
  'payment summary report': 'CLINIC_REPORTS.PAYMENT_SUMMARY_REPORT_FREQUENCY',
  'statement activity summary report':
    'CLINIC_REPORTS.STATEMENT_ACTIVITY_SUMMARY_REPORT_FREQUENCY'
};

export const PhoneTypes = [
  {
    name: 'DUE_INVOICES.PHONE_TYPE_MOBILE',
    value: 'mobile'
  },
  {
    name: 'DUE_INVOICES.PHONE_TYPE_NON_MOBILE',
    value: 'non_mobile'
  },
  {
    name: 'DUE_INVOICES.PHONE_TYPE_NO_MOBILE',
    value: 'no_mobile'
  }
];

export const DeliveryStatus = [
  {
    name: 'NOTIFICATIONS_HISTORY.SENT',
    value: 'Sent'
  },
  {
    name: 'NOTIFICATIONS_HISTORY.PENDING',
    value: 'Pending'
  },
  {
    name: 'NOTIFICATIONS_HISTORY.FAILED',
    value: 'Failed'
  },
  {
    name: 'NOTIFICATIONS_HISTORY.QUEUED',
    value: 'Queued'
  },
  {
    name: 'NOTIFICATIONS_HISTORY.IGNORED',
    value: 'Ignored'
  }
];

export const TaskStatus = [
  {
    name: 'NOTIFICATIONS_HISTORY.UNASSIGNED',
    value: 'new'
  },
  {
    name: 'NOTIFICATIONS_HISTORY.INPROGRESS',
    value: 'in progress'
  },
  {
    name: 'NOTIFICATIONS_HISTORY.WAITING',
    value: 'waiting'
  },
  {
    name: 'NOTIFICATIONS_HISTORY.IGNORED',
    value: 'ignored'
  },
  {
    name: 'NOTIFICATIONS_HISTORY.COMPLETED',
    value: 'completed'
  }
];

export const StatementType = [
  {
    name: 'NOTIFICATIONS_HISTORY.REGULAR_DUE',
    value: 'RD'
  },
  {
    name: 'NOTIFICATIONS_HISTORY.PAST_DUE',
    value: 'PD'
  },
  {
    name: 'NOTIFICATIONS_HISTORY.FINAL_NOTICE',
    value: 'FN'
  }
];

export const NotificationTypeLabels = [
  {
    name: 'NOTIFICATIONS_HISTORY.EMAIL',
    value: 'email'
  },
  {
    name: 'NOTIFICATIONS_HISTORY.SMS',
    value: 'sms'
  }
];

export const ReportsObj = {
  PAYMENT_REPORT: 'payment summary report',
  MESSAGE_REPORT: 'message summary report',
  LAST_STATEMENT_SUMMARY: 'last import summary report',
  STATEMENT_ACTIVITY_SUMMARY: 'statement activity summary report'
};

export const DEFAULT_IMPORT_DAYS_DIFF = 28;

export const UserOrgGroupType = {
  REGISTERED: 'registered',
  INVITED: 'invited'
};

export const GuarantorPortalPaymentTypes = [
  {
    label: 'PAYMENTS_LOGIN.DASHBOARD.PAYMENT_TYPES.STATEMENT_PAY',
    value: PaymentTypes.STATEMENT_PAYMENT,
    amount_key: 'dueAmount'
  },
  {
    label: 'PAYMENTS_LOGIN.DASHBOARD.PAYMENT_TYPES.COPAY_AMOUNT',
    value: PaymentTypes.PATIENT_COPAY_PAYMENT,
    amount_key: 'copayAmount'
  }
];

export const PortalPaymentTypes = [
  {
    label: 'PAYMENTS_LOGIN.DASHBOARD.PAYMENT_TYPES.STATEMENT_PAY',
    value: PaymentTypes.STATEMENT_PAYMENT,
    amount_key: 'dueAmount'
  }
];

export const GuarantorPortalsTypesMap = {
  GUARANTOR: 'Guarantor',
  PRACTICE: 'Practice',
  APPOINTMENT: 'Appointment'
};

export const eligibilityStatus = [
  {
    id: 'not_applicable',
    name: 'APPOINTMENTS.NOT_APPLICABLE'
  },
  {
    id: 'policy_termed',
    name: 'APPOINTMENTS.POLICY_TERMED'
  },
  {
    id: 'self_pay',
    name: 'APPOINTMENTS.SELF_PAY'
  }
];

export const ReminderWorkFlowStatusTypes = {
  NEW: 'new',
  IN_PROGRESS: 'in progress',
  COMPLETED: 'completed',
  WAITING: 'waiting',
  IGNORED: 'ignored',
  PENDING: 'pending'
};

export const MessageEventTypeStatus = {
  PENDING: 'pending',
  IN_PROGRESS: 'in progress',
  COMPLETED: 'completed',
  IGNORE: 'ignored',
  DECLINED: 'declined',
  TASK_AS_NOT_DONE: 'task_as_not_done'
};

export const reminderWorkFlowStatus = [
  {
    id: 'new',
    name: 'WORK_FLOW_STATUSES.UNASSIGNED'
  },
  {
    id: 'in progress',
    name: 'WORK_FLOW_STATUSES.IN_PROGRESS'
  },
  {
    id: 'waiting',
    name: 'WORK_FLOW_STATUSES.WAITING'
  },
  {
    id: 'ignored',
    name: 'WORK_FLOW_STATUSES.IGNORED'
  },
  {
    id: 'completed',
    name: 'WORK_FLOW_STATUSES.COMPLETED'
  }
];

export const patientForms = [
  {
    id: 'not_sent',
    name: 'APPOINTMENTS.NOT_SENT'
  },
  {
    id: 'sent',
    name: 'APPOINTMENTS.SENT'
  },
  {
    id: 'completed',
    name: 'APPOINTMENTS.COMPLETED'
  },
  {
    id: 'reviewed',
    name: 'APPOINTMENTS.REVIEWED'
  }
];

export const MessageFilterTypes = {
  ALL: 'all',
  APPOINTMENT_REMINDER: 'appointment_reminder',
  UNREAD: 'unread',
  ARCHIVED: 'archived',
  OUTBOUND: 'outbound',
  INCOMING_PRIOR_AUTH_MESSAGE: 'incoming_prior_auth_message',
  INCOMING_PATIENT_RECALL_MESSAGE: 'incoming_patient_recall_reminder',
  INCOMING_CLAIM_MESSAGE: 'incoming_claim_message',
  INCOMING_INSURANCE_CARD_MESSAGE: 'incoming_insurance_card_message',
  INCOMING_STATEMENT_REMINDER: 'incoming_statement_reminder',
  INCOMING_APPOINTMENT_REMINDER: 'incoming_appointment_reminder'
};

// UPDATE GROUP INCOMING TYPE LABELS IN BACKEND, IF LABELS CHANGES
export const MessagesDataFilterTypes = [
  {
    id: 'all',
    name: 'INCOMING_SMS.ALL_INCOMING',
    key: 'incoming_all'
  },
  {
    id: 'unread',
    name: 'INCOMING_SMS.DATA_FILTERS.UNREAD',
    key: 'incoming_unread'
  },
  {
    id: 'appointment_reminder',
    name: 'INCOMING_SMS.DATA_FILTERS.APPOINTMENT_REMINDER_REPLIES',
    key: 'incoming_appointment_reminder'
  },
  {
    id: 'statement_reminder',
    name: 'INCOMING_SMS.DATA_FILTERS.STATEMENT_REMINDER_REPLIES',
    key: 'incoming_statement_reminder'
  },
  {
    id: 'patient_recall_reminder',
    name: 'INCOMING_SMS.DATA_FILTERS.PATIENT_RECALL_REMINDER_REPLIES',
    key: 'incoming_patient_recall_reminder'
  },
  {
    id: 'prior_auth_message',
    name: 'INCOMING_SMS.DATA_FILTERS.PRIOR_AUTHORIZATIONS_REPLIES',
    key: 'incoming_prior_auth_message'
  },
  {
    id: 'claim_message',
    name: 'INCOMING_SMS.DATA_FILTERS.CLAIMS_REPLIES',
    key: 'incoming_claim_message'
  },
  {
    id: 'insurance_card_message',
    name: 'INCOMING_SMS.DATA_FILTERS.INSURANCE_CARD_REPLIES',
    key: MessageFilterTypes.INCOMING_INSURANCE_CARD_MESSAGE
  }
];

export const MessagesDataEventTypeStatus = [
  {
    id: 'pending',
    name: 'INCOMING_SMS.PENDING'
  },
  {
    id: 'in progress',
    name: 'INCOMING_SMS.IN_PROGRESS'
  },
  {
    id: 'completed',
    name: 'INCOMING_SMS.COMPLETED'
  },
  {
    id: 'ignored',
    name: 'INCOMING_SMS.IGNORED'
  }
];

export const APPOINTMENT_ACTIONS = {
  ELIGIBILITY_STATUS: 'eligibility_status',
  PATIENT_FORMS: 'patient_forums'
};

export const IMPORT_TYPES_DROPDOWN = [
  {value: 'patient', label: 'Patients'},
  {value: 'patient_copay', label: 'Patient Copay'},
  {value: 'appointment', label: 'Appointments'}
];

export const NOTIFICATIONS_HISTORY = {
  APPOINTMENT: 'appointment'
};
export const EMRProviderIDs = {
  ECW: 1,
  OFFICE_ALLY_AND_PRACTICE_MATE: 2,
  CENTRICITY: 3,
  ALL_SCRIPT: 4,
  ALL_SCRIPT_V2: 5,
  MODMED: 6,
  EPIC: 7,
  GENERIC: 10,
  ADVANCED_MD: 11,
  OPEN_DENTAL: 13
};

export const EMRProviderKey = {
  ECW: 'ecw',
  OFFICE_ALLY_AND_PRACTICE_MATE: 'office_ally_and_practice_mate',
  CENTRICITY: 'centricity',
  ALL_SCRIPT: 'all_scripts',
  EPIC: 'EPIC',
  OPEN_DENTAL: 'opendental'
};

export const EMRProviders = {
  GENERIC: 'Generic',
  OPEN_DENTAL: 'Open Dental'
};

export const AppointmentStatus = {
  CONFIRMED: 'confirmed_on_patient_care_link',
  DECLINED: 'declined_on_patient_care_link',
  SCHEDULED_PCL: 'scheduled_on_patient_care_link',
  UPDATED_PCL: 'updated_on_patient_care_link',
  CANCELLED_PCL: 'cancelled_on_patient_care_link',
  COMPLETED_PCL: 'completed_on_patient_care_link',
  SCHEDULED_VOICE_ASSISTANT: 'scheduled_on_voice_assistant',
  CANCELLED_VOICE_ASSISTANT: 'cancelled_on_voice_assistant',
  UPDATED_VOICE_ASSISTANT: 'updated_on_voice_assistant'
};

export const RMD_APPOINTMENT_STATUSES: string[] = [
  AppointmentStatus.SCHEDULED_VOICE_ASSISTANT,
  AppointmentStatus.UPDATED_VOICE_ASSISTANT,
  AppointmentStatus.CANCELLED_VOICE_ASSISTANT,
  AppointmentStatus.SCHEDULED_PCL,
  AppointmentStatus.UPDATED_PCL,
  AppointmentStatus.CANCELLED_PCL,
  AppointmentStatus.COMPLETED_PCL,
  AppointmentStatus.CONFIRMED,
  AppointmentStatus.DECLINED
];

export const AppointmentSource = {
  ADMIN: 'Admin',
  PATIENT_PORTAL: 'Patient Portal',
  VOICE_ASSISTANT: 'Voice Assistant',
  EMR_IMPORT: 'EMR Import',
  EMR_INTEGRATION: 'EMR Integration'
};

export const RMD_APPOINTMENT_SOURCES: string[] = [
  AppointmentSource.ADMIN,
  AppointmentSource.PATIENT_PORTAL,
  AppointmentSource.VOICE_ASSISTANT
];

export const VaccineStatusMapping = [
  {
    id: AppointmentStatus.SCHEDULED_PCL,
    name: 'APPOINTMENTS_SCHEDULAR_PORTAL.APPOINTMENTS.SCHEDULED'
  },
  {
    id: AppointmentStatus.COMPLETED_PCL,
    name: 'APPOINTMENTS_SCHEDULAR_PORTAL.APPOINTMENTS.COMPLETED'
  },
  {
    id: AppointmentStatus.CANCELLED_PCL,
    name: 'APPOINTMENTS_SCHEDULAR_PORTAL.APPOINTMENTS.CANCELLED'
  }
];

export const ClaimStatus = {
  PENDING: 'pending',
  SUBMITTED: 'submitted',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  DENIED: 'denied'
};

export const ClaimStatusObject = {
  [ClaimStatus.PENDING]: `APPOINTMENTS.CLAIM_STATUS.PENDING`,
  [ClaimStatus.SUBMITTED]: `APPOINTMENTS.CLAIM_STATUS.SUBMITTED`,
  [ClaimStatus.ACCEPTED]: `APPOINTMENTS.CLAIM_STATUS.ACCEPTED`,
  [ClaimStatus.REJECTED]: `APPOINTMENTS.CLAIM_STATUS.REJECTED`,
  [ClaimStatus.DENIED]: `APPOINTMENTS.CLAIM_STATUS.DENIED`
};

export const ClaimStatusMapping = [
  {
    id: ClaimStatus.PENDING,
    name: 'APPOINTMENTS.CLAIM_STATUS.PENDING'
  },
  {
    id: ClaimStatus.SUBMITTED,
    name: 'APPOINTMENTS.CLAIM_STATUS.SUBMITTED'
  },
  {
    id: ClaimStatus.ACCEPTED,
    name: 'APPOINTMENTS.CLAIM_STATUS.ACCEPTED'
  },
  {
    id: ClaimStatus.REJECTED,
    name: 'APPOINTMENTS.CLAIM_STATUS.REJECTED'
  },
  {
    id: ClaimStatus.DENIED,
    name: 'APPOINTMENTS.CLAIM_STATUS.DENIED'
  }
];

export const ACHStatus = {
  PENDING: 'pending',
  SENT: 'sent'
};

export const ACHStatusObject = {
  [ACHStatus.PENDING]: `APPOINTMENTS.ACH_STATUS.PENDING`,
  [ACHStatus.SENT]: `APPOINTMENTS.ACH_STATUS.SENT`
};

export const ACHStatusMapping = [
  {
    id: ACHStatus.PENDING,
    name: 'APPOINTMENTS.ACH_STATUS.PENDING'
  },
  {
    id: ACHStatus.SENT,
    name: 'APPOINTMENTS.ACH_STATUS.SENT'
  }
];

/*
@description - Mapping of Appointment Status
*/
export const AppointmentStatusMapping = [
  {
    id: 'confirmed_on_patient_care_link',
    name: 'APPOINTMENT_STATUS.CONFIRMED_ON_PATIENT_CARE_LINK'
  },
  {
    id: 'declined_on_patient_care_link',
    name: 'APPOINTMENT_STATUS.DECLINED_ON_PATIENT_CARE_LINK'
  },
  {
    id: 'scheduled_on_patient_care_link',
    name: 'APPOINTMENT_STATUS.SCHEDULED_ON_PATIENT_CARE_LINK'
  },
  {
    id: 'updated_on_patient_care_link',
    name: 'APPOINTMENT_STATUS.UPDATED_ON_PATIENT_CARE_LINK'
  },
  {
    id: 'cancelled_on_patient_care_link',
    name: 'APPOINTMENT_STATUS.CANCELLED_ON_PATIENT_CARE_LINK'
  },
  {
    id: 'completed_on_patient_care_link',
    name: 'APPOINTMENT_STATUS.COMPLETED_ON_PATIENT_CARE_LINK'
  },
  {
    id: 'scheduled_on_voice_assistant',
    name: 'APPOINTMENT_STATUS.SCHEDULED_ON_VOICE_ASSISTANT'
  },
  {
    id: 'cancelled_on_voice_assistant',
    name: 'APPOINTMENT_STATUS.CANCELLED_ON_VOICE_ASSISTANT'
  },
  {
    id: 'updated_on_voice_assistant',
    name: 'APPOINTMENT_STATUS.UPDATED_ON_VOICE_ASSISTANT'
  }
];

export const CUSTOM_NOTIFICATION_TYPES = {
  CUSTOM_MESSAGE_SEND: 'custom_message_send',
  CUSTOM_MESSAGE_SCHEDULE_SEND: 'custom_message_schedule_send'
};
export function getChargeTypeLabel(key: string): string {
  let chareTypeLabel = '';
  switch (key) {
    case PaymentTypes.PATIENT_COPAY_PAYMENT:
      chareTypeLabel = 'CHARGE_TYPES.PATIENT_COPAY_PAYMENT';
      break;
    case PaymentTypes.STATEMENT_ADJUSTMENT:
      chareTypeLabel = 'CHARGE_TYPES.STATEMENT_ADJUSTMENT';
      break;
    case PaymentTypes.PAST_STATEMENT_ADJUSTMENT:
      chareTypeLabel = 'CHARGE_TYPES.PAST_STATEMENT_PAYMENT';
      break;
    case PaymentTypes.OTHER:
      chareTypeLabel = 'CHARGE_TYPES.OTHER';
      break;
    case PaymentTypes.CONVENIENCE_FEE:
      chareTypeLabel = 'CHARGE_TYPES.CONVENIENCE_FEE';
      break;
    case PaymentTypes.IMMIGRATION_HEALTH_CHECK:
      chareTypeLabel = 'CHARGE_TYPES.IMMIGRATION_HEALTH_CHECK';
      break;
    default:
      chareTypeLabel = '';
  }
  return chareTypeLabel;
}
export const SMS_DIRECTION = {
  INBOUND: 'inbound',
  OUTBOUND: 'outbound'
};

export const MiscChargeTypesPriorityOrder = {
  'patient copay payment': 1,
  'past statement payment': 2,
  'statement adjustment': 3,
  'immigration health check': 4,
  other: 5
};
export const OPT_OUT_ELECTRONIC_STATEMENTS_FILTERS = [
  {
    label: 'Yes',
    value: true,
    text: 'OPT_OUT_ELECTRONIC_STATEMENT_YES_TEXT'
  },
  {
    label: 'No',
    value: false,
    text: 'OPT_OUT_ELECTRONIC_STATEMENT_NO_TEXT'
  }
];
export const PATIENT_FIELDS = {
  PATIENT_FIRST_NAME: 'patient_first_name',
  PATIENT_MIDDLE_NAME: 'patient_middle_name',
  PATIENT_LAST_NAME: 'patient_last_name',
  PATIENT_ACCOUNT_NUMBER: 'patient_account_number',
  PATIENT_DATE_OF_BIRTH: 'patient_dob',
  PATIENT_GENDER: 'patient_gender',
  PATIENT_PHONE_NUMBER: 'patient_phone',
  PATIENT_EMAIL: 'patient_email',
  PATIENT_ADDRESS_LINE_1: 'patient_address_line_1',
  PATIENT_ADDRESS_LINE_2: 'patient_address_line_2',
  PATIENT_CITY: 'patient_city',
  PATIENT_STATE: 'patient_state',
  PATIENT_ZIP: 'patient_zip'
};

export const PaymentPlanStatus = {
  INSTALMENT: 'payment-plan-instalment',
  IN_PROGRESS: 'in-progress',
  PENDING: 'pending',
  COMPLETED: 'completed',
  PAID: 'paid',
  PARTIALLY_PAID: 'partially-paid',
  CANCELLED: 'cancelled',
  FAILED: 'failed',
  IGNORED: 'ignored'
};

export const paymentMethodTypes = {
  PAY_NOW: 'pay_now',
  PAY_IN_INSTALLMENTS: 'pay_in_installments',
  PAY_CASH: 'pay_cash'
};

export const minimumPaymentPlanInstallments = 2;

export const paymentPlanStatusArray = [
  {
    name: 'PAYMENT_PLANS.ACTIVE',
    value: 'in-progress'
  },
  {
    name: 'PAYMENT_PLANS.CANCELLED',
    value: 'cancelled'
  },
  {
    name: 'PAYMENT_PLANS.COMPLETED',
    value: 'completed'
  }
];

export const PatientRecallFAQTypes = [
  {
    id: 'last week',
    name: 'PATIENT_RECALL.SHOW_LAST_WEEK_RECOMMENDED_WELLNESS_CHECKS'
  }
];

export const PatientRecallReminderStatusMapping = [
  {
    id: 'pending',
    name: 'PATIENT_RECALL.PENDING',
    label: 'PATIENT_RECALL.REMINDER_TO_BE_SENT'
  },
  {
    id: 'sent',
    name: 'PATIENT_RECALL.SENT',
    label: 'PATIENT_RECALL.SENT_SUCCESSFULLY'
  },
  {
    id: 'failed',
    name: 'PATIENT_RECALL.FAILED',
    label: 'PATIENT_RECALL.SEND_FAILED'
  },
  {
    id: 'ignored',
    name: 'PATIENT_RECALL.IGNORED',
    label: 'PATIENT_RECALL.SEND_IGNORED'
  }
];

export const PatientRecallMetricTypes = [
  {
    id: 'current month',
    name: 'PATIENT_RECALL.CURRENT_MONTH'
  },
  {
    id: 'last month',
    name: 'PATIENT_RECALL.LAST_MONTH'
  },
  {
    id: 'year to date',
    name: 'PATIENT_RECALL.YEAR_TO_DATE'
  },
  {
    id: 'current year',
    name: 'PATIENT_RECALL.CURRENT_YEAR'
  },
  {
    id: 'last year',
    name: 'PATIENT_RECALL.LAST_YEAR'
  }
];

export const PatientRecallOptOutTypes = [
  {
    id: 'selected milestone',
    name: 'PATIENT_RECALL.SELECTED_MILESTONE'
  },
  {
    id: 'all future milestones',
    name: 'PATIENT_RECALL.ALL_FUTURE_MILESTONES'
  }
];

export const PatientRecallAppointmentStatusMapping = [
  {
    id: 'pending',
    name: 'PATIENT_RECALL.PENDING'
  },
  {
    id: 'scheduled',
    name: 'PATIENT_RECALL.SCHEDULED'
  },
  {
    id: 'cancelled',
    name: 'PATIENT_RECALL.CANCELLED'
  },
  {
    id: 'completed',
    name: 'PATIENT_RECALL.COMPLETED'
  }
];

export const PatientRecallReferenceDataTypes = {
  CATEGORY: 'category',
  MILESTONE_TYPE: 'milestone_type'
};

export const PatientRecallWellCheckStatusObj = {
  UPCOMING: 'upcoming',
  MISSED: 'missed',
  IGNORED: 'ignored',
  COMPLETED: 'completed',
  UNKNOWN: 'unknown'
};

export const PatientRecallWellCheckStatusMapping = [
  {
    id: PatientRecallWellCheckStatusObj.COMPLETED,
    name: 'PATIENT_RECALL.COMPLETED',
    color: APP.COLOR.WELLCHECK_STATUS.COMPLETED
  },
  {
    id: PatientRecallWellCheckStatusObj.UPCOMING,
    name: 'PATIENT_RECALL.UPCOMING',
    color: APP.COLOR.WELLCHECK_STATUS.UPCOMING
  },
  {
    id: PatientRecallWellCheckStatusObj.MISSED,
    name: 'PATIENT_RECALL.MISSED',
    color: APP.COLOR.WELLCHECK_STATUS.MISSED
  },
  {
    id: PatientRecallWellCheckStatusObj.IGNORED,
    name: 'PATIENT_RECALL.OPTEDOUT',
    color: APP.COLOR.WELLCHECK_STATUS.MISSED
  },
  {
    id: PatientRecallWellCheckStatusObj.UNKNOWN,
    name: 'PATIENT_RECALL.UNKNOWN',
    color: APP.COLOR.WELLCHECK_STATUS.UNKNOWN
  }
];

export const PatientRecallVisitType = {
  Last: {
    labelKey: 'PATIENT_RECALL.LAST_VISIT',
    value: 'last'
  },
  Next: {
    labelKey: 'PATIENT_RECALL.NEXT_VISIT',
    value: 'next'
  }
};

export const ORG_GROUP_TYPE = [
  {name: 'practice group', label: 'Practice Group'},
  {name: 'billing group', label: 'Billing Group'}
];

export const ORGANIZATION_GROUP_TYPES = {
  BILLING_GROUP_LABEL: 'Billing Group',
  PRACTICE_GROUP_LABEL: 'Practice Group',
  BILLING_GROUP_VALUE: 'billing group',
  PRACTICE_GROUP_VALUE: 'practice group'
};

export const PATIENT_SEARCH_ATTRIBUTES = {
  PATIENT_NAME: 'patientName',
  PATIENT_PHONE_NUMBER: 'patientPhoneNo',
  PATIENT_EMAIL: 'patientEmail',
  GUARANTOR_NAME: 'guarantorName',
  GUARANTOR_ACCOUNT_NUMBER: 'guarantorAccountNo',
  GUARANTOR_PHONE_NUMBER: 'guarantorPhoneNo',
  GUARANTOR_EMAIL: 'guarantorEmail',
  USER_LIST: 'userList'
};

export const NotificationTypeFilter = [
  {key: NotificationType.SMS, label: 'DUE_INVOICES.PLACEHOLDERS.SMS'},
  {key: NotificationType.EMAIL, label: 'DUE_INVOICES.PLACEHOLDERS.EMAIL'}
];

export const TaskFlowMessagesStatus = (t: any) => {
  return [
    {
      id: 'pending',
      name: t('WORK_FLOW_STATUSES.PENDING')
    },
    {
      id: 'in progress',
      name: t('WORK_FLOW_STATUSES.IN_PROGRESS')
    },
    {
      id: 'ignored',
      name: t('WORK_FLOW_STATUSES.IGNORED')
    },
    {
      id: 'completed',
      name: t('WORK_FLOW_STATUSES.COMPLETED')
    }
  ];
};

export const ChargeTypeLabels = [
  {
    id: PaymentTypes.PATIENT_COPAY_PAYMENT,
    name: 'CHARGE_TYPES.PATIENT_COPAY_PAYMENT'
  },
  {
    id: PaymentTypes.CONVENIENCE_FEE,
    name: 'CHARGE_TYPES.CONVENIENCE_FEE'
  },
  {
    id: PaymentTypes.STATEMENT_PAYMENT,
    name: 'CHARGE_TYPES.STATEMENT_PAYMENT'
  }
];

export const MessageTagTypes = [
  {
    id: 'appointment_reminder',
    name: 'INCOMING_SMS.APPOINTMENT_REMINDER_REPLY'
  },
  {
    id: 'statement_reminder',
    name: 'INCOMING_SMS.STATEMENT_REMINDER_REPLY'
  },
  {
    id: 'patient_recall_reminder',
    name: 'INCOMING_SMS.PATIENT_RECALL_REMINDER_REPLY'
  },
  {
    id: 'appointment_patient_review_reminder',
    name: 'INCOMING_SMS.GATHER_FEEDBACK_REPLY'
  },
  {
    id: 'prior_auth_message',
    name: 'INCOMING_SMS.PRIOR_AUTH_REPLY'
  },
  {
    id: 'claim_message',
    name: 'INCOMING_SMS.CLAIM_REPLY'
  },
  {
    id: 'insurance_missing_reminder',
    name: 'INCOMING_SMS.INSURANCE_CARD_REPLY'
  },
  {
    id: 'insurance_cards_failed_reminder',
    name: 'INCOMING_SMS.INSURANCE_CARD_REPLY'
  }
];

export const OutgoingTagTypes = [
  {
    id: 'outbound',
    name: 'INCOMING_SMS.ALL_OUTGOING',
    key: 'outgoing_all'
  },
  {
    id: 'outgoing_appointment_reminder',
    name: 'INCOMING_SMS.APPOINTMENT_REMINDER',
    key: 'outgoing_appointment_reminder'
  },
  {
    id: 'outgoing_statement_reminder',
    name: 'INCOMING_SMS.STATEMENT_REMINDER',
    key: 'outgoing_statement_reminder'
  },
  {
    id: 'outgoing_patient_recall_reminder',
    name: 'INCOMING_SMS.PATIENT_RECALL_REMINDER',
    key: 'outgoing_patient_recall_reminder'
  }
];

export const MimeTypeFileExtensions = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio'
};

export const FileExtensions = {
  IMAGE: ['jpg', 'jpeg', 'png', 'svg', 'gif'],
  VIDEO: ['mp4', 'webm', 'ogg'],
  AUDIO: ['mp3', 'ogg', 'amr', 'wav', 'm4a', 'aac', 'flac', 'wma']
};

export const FileTypes = {
  SMS: 'SMS',
  MMS: 'MMS'
};

export const SendCustomMessageTypes = {
  STATEMENT: 'Statement',
  APPOINTMENT: 'Appointment'
};

export const MIN_INSTALMENTS = 1;
export const MAX_INSTALMENTS = 200;
export const MAX_INSTALMENT_PAYMENT = 10000;

export const NotificationTypeReminders = {
  STATEMENT: 'statement',
  APPOINTMENT: 'appointment',
  PATIENT_RECALL: 'patient recall'
};

export const INCOMING_MESSAGES_DEFAULT_FILTER_VALUE = 'pending';

export const PAYMENT_PLAN_FREQUENCY_IDS = {
  MONTHLY: 1,
  WEEKLY: 2,
  BI_WEEKLY: 3
};

export function getPaymentPlanFrequencyLabel(key: number): string {
  let frequencyLabel = '';
  switch (key) {
    case PAYMENT_PLAN_FREQUENCY_IDS.MONTHLY:
      frequencyLabel = 'PAYMENT_PLANS.MONTHLY';
      break;
    case PAYMENT_PLAN_FREQUENCY_IDS.WEEKLY:
      frequencyLabel = 'PAYMENT_PLANS.WEEKLY';
      break;
    case PAYMENT_PLAN_FREQUENCY_IDS.BI_WEEKLY:
      frequencyLabel = 'PAYMENT_PLANS.BI_WEEKLY';
      break;
    default:
      frequencyLabel = '';
  }
  return frequencyLabel;
}

export const CardMachineStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};

export const PatientsTabKeys = {
  PATIENT_DETAILS: 'PATIENT_DETAILS',
  STATEMENTS: 'STATEMENTS',
  PAYMENTS: 'PAYMENTS',
  MESSAGES: 'MESSAGES',
  APPOINTMENTS: 'APPOINTMENTS',
  RECALL_ANALYSIS: 'RECALL_ANALYSIS',
  CCM: 'CCM',
  INSURANCE: 'INSURANCE',
  PRIOR_AUTHORIZATION: 'PRIOR_AUTHORIZATION',
  CLAIMS_TICKETS: 'CLAIMS_TICKETS',
  REFERRALS_TICKETS: 'REFERRALS_TICKETS',
  PHARMACY_CLAIMS: 'PHARMACY_CLAIMS',
  ELIGIBILITY_VERIFICATION: 'ELIGIBILITY_VERIFICATION'
} as const;

/** Voice call sessions list — appointment action status labels (row display + filter UI). */
export const APPOINTMENT_STATUS_LABEL_MAP: Record<string, string> = {
  CREATED: 'Appointment Created',
  UPDATED: 'Appointment Updated',
  CANCELLED: 'Appointment Cancelled',
  FLAGGED: 'Flagged',
  EMERGENCY: 'Emergency',
  RESOLVED: 'Resolved'
};

/** Keys above map to API query values for `appointmentStatusFilter`. */
export const APPOINTMENT_STATUS_MAPPING = {
  CREATED: 'created',
  UPDATED: 'updated',
  CANCELLED: 'cancelled',
  FLAGGED: 'flagged',
  EMERGENCY: 'emergency',
  RESOLVED: 'resolved'
} as const;

/** Voice / AI appointment call flow — maps API conversationStage keys to display labels */
export const APPOINTMENT_CONVERSATION_STAGES = [
  {key: 'greeting-stage', label: 'Greeting'},
  {key: 'safety-check-stage', label: 'Safety Check'},
  {key: 'classification-stage', label: 'Classification'},
  {key: 'provider-selection-stage', label: 'Provider Selection'},
  {key: 'availability-check-stage', label: 'Availability Check'},
  {key: 'patient-info-stage', label: 'Patient Info'},
  {
    key: 'patient-insurance-info-stage',
    label: 'Patient Insurance Information Collection'
  },
  {key: 'slot-selection-stage', label: 'Slot Selection'},
  {key: 'booking-stage', label: 'Booking'},
  {key: 'confirmation-stage', label: 'Confirmation'},
  {key: 'end-call-stage', label: 'End Call'}
] as const;

export function getAppointmentConversationStageLabel(
  stageKey: string | null | undefined
): string {
  if (stageKey == null || String(stageKey).trim() === '') {
    return '—';
  }
  const normalized = String(stageKey).toLowerCase().trim().replace(/_/g, '-');
  if (normalized === 'completed') {
    return 'Completed';
  }
  const found = APPOINTMENT_CONVERSATION_STAGES.find(s => s.key === normalized);
  return found?.label ?? String(stageKey);
}

export const messageInBoxesTypeKeys = [
  'my_inbox',
  'general_inbox',
  'un_attended_over_24h'
];

export const messageInBoxesTypesObject = {
  MY_INBOX: 'my_inbox',
  GENERAL_INBOX: 'general_inbox',
  UN_ATTENDED_OVER_24H: 'un_attended_over_24h',
  CUSTOM_MESSAGE_INBOX: 'custom_message_inbox'
};

export const BALANCE_TYPE_KEYS = {
  STATEMENT_BALANCE_KEY: 'original_due_amount',
  COPAY_BALANCE_KEY: 'charge_amount',
  STATEMENT_BALANCE_PAID: 'paid_due_amount',
  COPAY_BALANCE_PAID: 'paid_amount'
};

export const PAYMENT_PLAN_DEBOUNCE_DELAY = 250;
export const messagesCategory = {
  BILLING: 'billing',
  CLINICAL: 'clinical'
};

export const PatientDetailTabs = {
  PATIENT_DETAILS: 'patient_details',
  RECALL_ANALYSIS: 'recall_analysis',
  INSURANCE: 'insurance'
};

// export const verificationStatus = [
//   {
//     id: 'manually-verified',
//     name: 'APPOINTMENTS.MANUALLY_VERIFIED'
//   },
//   {
//     id: 'automatic-verified',
//     name: 'APPOINTMENTS.AUTOMATIC_VERIFIED'
//   },
//   {
//     id: 'not_verified',
//     name: 'APPOINTMENTS.NOT_VERIFIED'
//   }
// ];

export const VerificationStatusObj = {
  VERIFIED: 'verified',
  NOT_VERIFIED: 'not_verified',
  MANUALLY_VERIFIED: 'manually-verified',
  AUTOMATIC_VERIFIED: 'automatic-verified'
};
export const VerificationStatusMapping = [
  {
    id: VerificationStatusObj.AUTOMATIC_VERIFIED,
    name: 'APPOINTMENTS.AUTOMATIC_VERIFIED'
  },
  {
    id: VerificationStatusObj.MANUALLY_VERIFIED,
    name: 'APPOINTMENTS.MANUALLY_VERIFIED'
  },
  {
    id: VerificationStatusObj.NOT_VERIFIED,
    name: 'APPOINTMENTS.NOT_VERIFIED'
  }
];

export const BenefitStatusObj = {
  NO_INFORMATION: 'no_information',
  NOT_APPLICABLE: 'not_applicable',
  POLICY_TERMED: 'policy_termed',
  SELF_PAY: 'self_pay',
  COVERAGE_UNKNOWN: 'Coverage Unknown',
  ACTIVE_COVERAGE: 'Active Coverage',
  ACTIVE_FULL_RISK: 'Active - Full Risk Capitation',
  ACTIVE_CAPITATED: 'Active - Services Capitated',
  ACTIVE_CAPITATED_TO_CARE:
    'Active - Services Capitated to Primary Care Physician',
  ACTIVE_PENDING_INVESTIGATION: 'Active - Pending Investigation',
  INACTIVE: 'Inactive',
  INACTIVE_PENDING_ELIGIBILITY_UPDATE: 'Inactive - Pending Eligibility Update',
  INACTIVE_PENDING_INVESTIGATION: 'Inactive - Pending Investigation',
  ACTIVE: 'active'
};

export const EligibilityStatusObj = {
  NOT_APPLICABLE: 'not_applicable',
  POLICY_TERMED: 'policy_termed',
  SELF_PAY: 'self_pay',
  // TODO: Why are we not using it?
  COVERAGE_UNKNOWN: 'coverage_unknown',
  ACTIVE_COVERAGE: 'active_coverage',
  ACTIVE_FULL_RISK: 'active _full_risk_capitation',
  ACTIVE_CAPITATED: 'active_services_capitated',
  ACTIVE_CAPITATED_TO_CARE:
    'active_services_capitated_to_primary_care_physician',
  ACTIVE_PENDING_INVESTIGATION: 'active_pending_investigation',
  INACTIVE: 'inactive',
  INACTIVE_PENDING_ELIGIBILITY_UPDATE: 'inactive_pending_eligibility_update',
  INACTIVE_PENDING_INVESTIGATION: 'inactive_pending_investigation',
  NO_INFORMATION: 'no_information',
  ACTIVE: 'active',
  REJECTED: 'rejected',
  FAILED: 'failed'
};

export const EligibilityStatus = [
  EligibilityStatusObj.ACTIVE,
  EligibilityStatusObj.ACTIVE_COVERAGE,
  EligibilityStatusObj.ACTIVE_FULL_RISK,
  EligibilityStatusObj.ACTIVE_CAPITATED,
  EligibilityStatusObj.ACTIVE_CAPITATED_TO_CARE,
  EligibilityStatusObj.INACTIVE,
  EligibilityStatusObj.INACTIVE_PENDING_ELIGIBILITY_UPDATE,
  EligibilityStatusObj.INACTIVE_PENDING_INVESTIGATION
];

export const ActiveEligibilityStatusKeys = [
  EligibilityStatusObj.ACTIVE,
  EligibilityStatusObj.ACTIVE_CAPITATED,
  EligibilityStatusObj.ACTIVE_CAPITATED_TO_CARE,
  EligibilityStatusObj.ACTIVE_COVERAGE,
  EligibilityStatusObj.ACTIVE_FULL_RISK,
  EligibilityStatusObj.ACTIVE_PENDING_INVESTIGATION
];

export const EligibilityStatusMappingObj = {
  [EligibilityStatusObj.ACTIVE]: {
    id: EligibilityStatusObj.ACTIVE,
    color: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_COLOR,
    borderColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BORDER_COLOR,
    name: 'APPOINTMENTS.ACTIVE',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BACKGROUND_COLOR
  },
  [EligibilityStatusObj.ACTIVE_COVERAGE]: {
    id: EligibilityStatusObj.ACTIVE_COVERAGE,
    color: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_COLOR,
    borderColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BORDER_COLOR,
    name: 'APPOINTMENTS.ACTIVE_COVERAGE',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BACKGROUND_COLOR
  },
  [EligibilityStatusObj.ACTIVE_FULL_RISK]: {
    id: EligibilityStatusObj.ACTIVE_FULL_RISK,
    borderColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BORDER_COLOR,
    color: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_COLOR,
    name: 'APPOINTMENTS.ACTIVE_FULL_RISK',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BACKGROUND_COLOR
  },
  [EligibilityStatusObj.ACTIVE_CAPITATED]: {
    id: EligibilityStatusObj.ACTIVE_CAPITATED,
    borderColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BORDER_COLOR,
    color: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_COLOR,
    name: 'APPOINTMENTS.ACTIVE_CAPITATED',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BACKGROUND_COLOR
  },
  [EligibilityStatusObj.ACTIVE_CAPITATED_TO_CARE]: {
    id: EligibilityStatusObj.ACTIVE_CAPITATED_TO_CARE,
    borderColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BORDER_COLOR,
    color: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_COLOR,
    name: 'APPOINTMENTS.ACTIVE_CAPITATED_TO_CARE',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BACKGROUND_COLOR
  },
  [EligibilityStatusObj.ACTIVE_PENDING_INVESTIGATION]: {
    id: EligibilityStatusObj.ACTIVE_PENDING_INVESTIGATION,
    borderColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BORDER_COLOR,
    color: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_COLOR,
    name: 'APPOINTMENTS.ACTIVE_PENDING_INVESTIGATION',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BACKGROUND_COLOR
  },
  [EligibilityStatusObj.INACTIVE]: {
    id: EligibilityStatusObj.INACTIVE,
    borderColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BORDER_COLOR,
    color: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_COLOR,
    name: 'APPOINTMENTS.INACTIVE',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BACKGROUND_COLOR
  },
  [EligibilityStatusObj.INACTIVE_PENDING_ELIGIBILITY_UPDATE]: {
    id: EligibilityStatusObj.INACTIVE_PENDING_ELIGIBILITY_UPDATE,
    borderColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BORDER_COLOR,
    color: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_COLOR,
    name: 'APPOINTMENTS.INACTIVE_PENDING_ELIGIBILITY_UPDATE',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BACKGROUND_COLOR
  },
  [EligibilityStatusObj.INACTIVE_PENDING_INVESTIGATION]: {
    id: EligibilityStatusObj.INACTIVE_PENDING_INVESTIGATION,
    borderColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BORDER_COLOR,
    color: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_COLOR,
    name: 'APPOINTMENTS.INACTIVE_PENDING_INVESTIGATION',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BACKGROUND_COLOR
  },
  [EligibilityStatusObj.NO_INFORMATION]: {
    id: EligibilityStatusObj.NO_INFORMATION,
    borderColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BORDER_COLOR,
    color: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_COLOR,
    name: 'APPOINTMENTS.NO_INFORMATION',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BACKGROUND_COLOR
  },
  [EligibilityStatusObj.POLICY_TERMED]: {
    id: EligibilityStatusObj.POLICY_TERMED,
    borderColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BORDER_COLOR,
    color: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_COLOR,
    name: 'APPOINTMENTS.POLICY_TERMED',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BACKGROUND_COLOR
  },
  [EligibilityStatusObj.SELF_PAY]: {
    id: EligibilityStatusObj.SELF_PAY,
    borderColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BORDER_COLOR,
    color: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_COLOR,
    name: 'APPOINTMENTS.SELF_PAY',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BACKGROUND_COLOR
  },
  [EligibilityStatusObj.NOT_APPLICABLE]: {
    id: EligibilityStatusObj.NOT_APPLICABLE,
    borderColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BORDER_COLOR,
    color: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_COLOR,
    name: 'APPOINTMENTS.NOT_APPLICABLE',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BACKGROUND_COLOR
  },
  [EligibilityStatusObj.REJECTED]: {
    id: EligibilityStatusObj.REJECTED,
    color: APP.COLOR.ELIGIBILITY_STATUS.NOT_APPLICABLE_COLOR,
    borderColor: APP.COLOR.ELIGIBILITY_STATUS.NOT_APPLICABLE_BORDER_COLOR,
    name: 'APPOINTMENTS.REJECTED',
    backgroundColor:
      APP.COLOR.ELIGIBILITY_STATUS.NOT_APPLICABLE_BACKGROUND_COLOR
  },
  [EligibilityStatusObj.FAILED]: {
    id: EligibilityStatusObj.FAILED,
    color: APP.COLOR.ELIGIBILITY_STATUS.NOT_APPLICABLE_COLOR,
    borderColor: APP.COLOR.ELIGIBILITY_STATUS.NOT_APPLICABLE_BORDER_COLOR,
    name: 'APPOINTMENTS.FAILED',
    backgroundColor:
      APP.COLOR.ELIGIBILITY_STATUS.NOT_APPLICABLE_BACKGROUND_COLOR
  }
};

export const EligibilityStatusMapping = Object.values(
  EligibilityStatusMappingObj
);

export const BenefitStatusChipColorsObj = {
  [BenefitStatusObj.NOT_APPLICABLE]: {
    color: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_COLOR,
    name: 'APPOINTMENTS.NOT_APPLICABLE',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BACKGROUND_COLOR
  },
  [BenefitStatusObj.POLICY_TERMED]: {
    color: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_COLOR,
    name: 'APPOINTMENTS.POLICY_TERMED',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BACKGROUND_COLOR
  },
  [BenefitStatusObj.SELF_PAY]: {
    color: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_COLOR,
    name: 'APPOINTMENTS.SELF_PAY',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BACKGROUND_COLOR
  },
  // [BenefitStatusObj.COVERAGE_UNKNOWN]: {
  //   color: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE,
  //   name: EligibilityStatusObj.COVERAGE_UNKNOWN,
  //   backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BACKGROUND_COLOR
  // },
  [BenefitStatusObj.ACTIVE]: {
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BORDER_COLOR,
    name: 'APPOINTMENTS.ACTIVE',
    color: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_COLOR
  },
  [BenefitStatusObj.ACTIVE_COVERAGE]: {
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BORDER_COLOR,
    name: 'APPOINTMENTS.ACTIVE_COVERAGE',
    color: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_COLOR
  },
  [BenefitStatusObj.ACTIVE_FULL_RISK]: {
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BORDER_COLOR,
    name: 'APPOINTMENTS.ACTIVE_FULL_RISK',
    color: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_COLOR
  },
  [BenefitStatusObj.ACTIVE_CAPITATED]: {
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BORDER_COLOR,
    name: 'APPOINTMENTS.ACTIVE_CAPITATED',
    color: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_COLOR
  },
  [BenefitStatusObj.ACTIVE_CAPITATED_TO_CARE]: {
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BORDER_COLOR,
    name: 'APPOINTMENTS.ACTIVE_CAPITATED_TO_CARE',
    color: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_COLOR
  },
  [BenefitStatusObj.ACTIVE_PENDING_INVESTIGATION]: {
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BORDER_COLOR,
    name: 'APPOINTMENTS.ACTIVE_PENDING_INVESTIGATION',
    color: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_COLOR
  },
  [BenefitStatusObj.INACTIVE]: {
    color: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_COLOR,
    name: 'APPOINTMENTS.INACTIVE',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BORDER_COLOR
  },
  [BenefitStatusObj.INACTIVE_PENDING_ELIGIBILITY_UPDATE]: {
    color: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_COLOR,
    name: 'APPOINTMENTS.INACTIVE_PENDING_ELIGIBILITY_UPDATE',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BORDER_COLOR
  },
  [BenefitStatusObj.INACTIVE_PENDING_INVESTIGATION]: {
    color: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_COLOR,
    name: 'APPOINTMENTS.INACTIVE_PENDING_INVESTIGATION',
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BORDER_COLOR
  }
};

export const EligibilityLegends = [
  {
    color: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_COLOR,
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.ACTIVE_BORDER_COLOR,
    name: 'APPOINTMENTS.ELIGIBILITY_LEGEND.ACTIVE',
    value: 'active'
  },
  {
    color: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_COLOR,
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.IN_ACTIVE_BORDER_COLOR,
    name: 'APPOINTMENTS.ELIGIBILITY_LEGEND.INACTIVE',
    value: 'inactive'
  },
  {
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.NOT_APPLICABLE_BORDER_COLOR,
    color: APP.COLOR.ELIGIBILITY_STATUS.NOT_APPLICABLE_COLOR,
    name: 'APPOINTMENTS.ELIGIBILITY_LEGEND.NEEDS_ATTENTION',
    value: 'needs_attention'
  },
  {
    backgroundColor: APP.COLOR.ELIGIBILITY_STATUS.NOT_VERIFIED_BORDER_COLOR,
    color: APP.COLOR.ELIGIBILITY_STATUS.NOT_APPLICABLE_COLOR,
    name: 'APPOINTMENTS.ELIGIBILITY_LEGEND.NOT_VERIFIED',
    value: 'not_verified'
  }
];

export const GroupTabIds = {
  PRACTICE: 'practices',
  USER: 'users',
  CARD_MACHINES: 'card_machines',
  PROVIDERS: 'providers',
  BILLS: 'bills',
  PAYMENTS_HISTORY: 'payments_history',
  GROUP_PAYERS: 'group_payers',
  SCHEDULED_JOBS: 'scheduled_jobs',
  APPOINTMENT_SLOTS: 'appointments_slots',
  HOLIDAYS_LIST: 'holidays_list',
  VACCINES_LIST: 'vaccines_list',
  CLINIC_PROVIDERS: 'providers_list',
  SERVICE_LOCATION: 'service_location',
  EMR_REQUEST_LOGS: 'emr_request_logs',
  VOICE_AGENT_CONFIG: 'voice_agent_config',
  EMR_INTEGRATION: 'emr_integration'
};

export const MESSAGES_PANEL_LIST = {
  MESSAGES: 'My Messages',
  GROUP_MESSAGES: 'Group Messages',
  UN_ATTENDED_OVER: 'Unattended Over 24h',
  SENT_MESSAGES: 'Sent Messages',
  ARCHIVED_MESSAGES: 'Archived Messages'
};
export const MessagesLeftPanelList = [
  {name: 'My Messages'},
  {name: 'Group Messages'},
  {name: 'Unattended Over 24h'},
  {name: 'Sent Messages'}
];

export const messagesQuickFilterCountKeys = [
  'all',
  'unread',
  'statement_reminder',
  'appointment_reminder',
  'patient_recall_reminder',
  'un_attended_24h'
];

export const messageConversationActionKeys = {
  MARK_AS_NOT_DONE: 'mark_as_not_done',
  NON_CLINICAL: 'change_to_not_clinical_message',
  CLINICAL: 'change_to_clinical_message',
  MARK_AS_NEW: 'mark_as_new',
  MARK_AS_DONE: 'mark_as_done'
};

export const BenefitNetworkKeys = [
  'inNetwork',
  'outOfNetwork',
  'notApplicableNetwork',
  'noNetwork'
] as const;

export const BenefitNetworkChipColor: Record<
  typeof BenefitNetworkKeys[number],
  {backgroundColor: string; color: string}
> = {
  inNetwork: {
    color: 'white',
    backgroundColor: IN_NETWORK_COLOR
  },
  noNetwork: {
    color: 'white',
    backgroundColor: 'grey'
  },
  notApplicableNetwork: {
    color: 'white',
    backgroundColor: 'grey'
  },
  outOfNetwork: {
    color: 'white',
    backgroundColor: 'grey'
  }
};

export const networkKeyTranslationMapper = {
  inNetwork: 'IN_NETWORK',
  outOfNetwork: 'OUT_OF_NETWORK',
  notApplicableNetwork: 'NOT_APPLICABLE_NETWORK',
  noNetwork: 'NO_NETWORK'
};

export const amountKeyTranslationMapper = {
  coPayment: 'CO_PAYMENT',
  outOfPocket: 'OUT_OF_POCKET',
  deductibles: 'DEDUCTIBLES',
  coInsurance: 'CO_INSURANCE'
};

export const filterTimeList = [
  {label: 'No Time Spent', value: 'no_time_spent'},
  {label: 'Less than 20min', value: 'less_than_20'},
  {label: 'Less than 40min', value: 'less_than_40'},
  {label: 'Less than 60min', value: 'upto_60'},
  {label: 'More than 60min', value: 'more_than_60'}
];

export const PlanTaskTypes = {
  DATA_ENTRY: 'Data entry',
  INFORMATIONAL: 'Informational'
};

export const CCMPlanTaskArray = [
  {name: 'Data entry', value: PlanTaskTypes.DATA_ENTRY},
  {name: 'Informational', value: PlanTaskTypes.INFORMATIONAL}
];

export const FOLLOW_UP_NOTES_LOG_STATUS = {
  COMPLETED: 'completed',
  PENDING: 'pending'
};

export const BillingSuccessAndFailedList = {
  PATIENTS_FAILED: 'Patients with less than 20 minutes',
  PATIENTS_PASSED: 'Patients with 20+ minutes'
};

export const VaccineAppointmentSlotTypeKeys = {
  MORNING: 'morning',
  AFTERNOON: 'afternoon'
};
export const VaccineAppointmentSlotTypeTabs = [
  {
    key: VaccineAppointmentSlotTypeKeys.MORNING,
    label:
      'APPOINTMENTS_SCHEDULAR_PORTAL.UPLOAD_INSURANCE_CARD.MORNING_SLOT_LABEL'
  },
  {
    key: VaccineAppointmentSlotTypeKeys.AFTERNOON,
    label:
      'APPOINTMENTS_SCHEDULAR_PORTAL.UPLOAD_INSURANCE_CARD.AFTERNOON_SLOT_LABEL'
  }
];

export const VACCINE_INFO_KEY_MAPPER = {
  SHINGRIX: 'vis_shingrix',
  FLUARIX_QUADRIVALENT: 'vis_fluarix'
} as const;

export const FLU_VACCINE_QUESTION_ANSWER = {
  YES: 'APPOINTMENTS_SCHEDULAR_PORTAL.FLU_CONSENT_FORM.YES',
  NO: 'APPOINTMENTS_SCHEDULAR_PORTAL.FLU_CONSENT_FORM.NO',
  DONT_KNOW: "APPOINTMENTS_SCHEDULAR_PORTAL.FLU_CONSENT_FORM.DON'T_KNOW"
};

export const CONSENT_METADATA_STATUS_MAPPER = {
  COMPLETED: 'completed',
  IGNORED: 'ignored',
  NEEDS_ATTENTION: 'needs_attention'
};

export const APPOINTMENT_PATIENT_FEEDBACK = {
  REQUEST_REVIEW: {
    id: 'request_review',
    name: 'APPOINTMENTS.GOOD_VISIT'
  },
  PATIENT_REVIEW: {
    id: 'patient_review',
    name: 'APPOINTMENTS.GATHER_FEEDBACK'
  }
};

export const APPOINTMENT_PATIENT_FEEDBACK_FILTER_MAPPING = [
  {
    id: APPOINTMENT_PATIENT_FEEDBACK['REQUEST_REVIEW'].id,
    name: APPOINTMENT_PATIENT_FEEDBACK['REQUEST_REVIEW'].name
  },
  {
    id: APPOINTMENT_PATIENT_FEEDBACK['PATIENT_REVIEW'].id,
    name: APPOINTMENT_PATIENT_FEEDBACK['PATIENT_REVIEW'].name
  },
  {
    id: 'not_reviewed',
    name: 'APPOINTMENTS.FEEDBACK_NOT_REVIEWED'
  }
];
export const INSURANCE_SOURCE_MAPPER = {
  emr: {
    label: 'ELIGIBILITY_VERIFICATION.VERIFICATION_LOGS_DIALOG.SOURCE_ITEM.EMR',
    value: 'emr'
  },
  manual: {
    label:
      'ELIGIBILITY_VERIFICATION.VERIFICATION_LOGS_DIALOG.SOURCE_ITEM.MANUAL',
    value: 'manual'
  },
  card: {
    label: 'ELIGIBILITY_VERIFICATION.VERIFICATION_LOGS_DIALOG.SOURCE_ITEM.CARD',
    value: 'card'
  },
  voiceAssistant: {
    label:
      'ELIGIBILITY_VERIFICATION.VERIFICATION_LOGS_DIALOG.SOURCE_ITEM.VOICE_ASSISTANT',
    value: 'voice_assistant'
  }
};

export const INSURANCE_PROVIDER_KEYS_MAPPER = {
  AVAILITY: 'availity',
  ORBIT: 'orbithc'
};

export const INSURANCE_PROVIDER_MAPPER = [
  {
    id: INSURANCE_PROVIDER_KEYS_MAPPER.AVAILITY,
    label: 'ADD_CLINIC.AVAILITY'
  },
  {
    id: INSURANCE_PROVIDER_KEYS_MAPPER.ORBIT,
    label: 'ADD_CLINIC.ORBIT'
  }
];

export const BILLING_INVOICE_STATUS_MAPPER = [
  {
    id: 'pending',
    label: 'CLINICS.BILLS.INVOICE_STATUS.PENDING'
  },
  {
    id: 'paid',
    label: 'CLINICS.BILLS.INVOICE_STATUS.PAID'
  },
  {
    id: 'partially paid',
    label: 'CLINICS.BILLS.INVOICE_STATUS.PARTIALLY_PAID'
  },
  {
    id: 'cancelled',
    label: 'CLINICS.BILLS.INVOICE_STATUS.CANCELLED'
  },
  {
    id: 'failed',
    label: 'CLINICS.BILLS.INVOICE_STATUS.FAILED'
  }
];

// common items for prior auth nav
export const TICKETING_SYSTEM_CUSTOM_FILTER_KEY_MAPPER = {
  MY_PRIOR_AUTHORIZATIONS: 'my_prior_authorizations',
  ALL_PRIOR_AUTHORIZATIONS: 'all_prior_authorizations',
  UNASSIGNED_PRIOR_AUTHORIZATIONS: 'unassigned_prior_authorizations',
  UN_ATTENDED_TICKETS: 'unattended_tickets',
  AGE_BY: 'age_by',
  RESOLVED_TICKETS: 'resolved_ticket',
  NEEDS_CLINIC_ATTENTION: 'needs_clinic_attention',
  CLOSED_TICKETS: 'closed_tickets'
} as const;

export const TICKETING_SYSTEM_CUSTOM_FILTERS = [
  {
    id: TICKETING_SYSTEM_CUSTOM_FILTER_KEY_MAPPER.MY_PRIOR_AUTHORIZATIONS,
    name: 'MY_TICKETS_LABEL'
  },
  {
    id: TICKETING_SYSTEM_CUSTOM_FILTER_KEY_MAPPER.ALL_PRIOR_AUTHORIZATIONS,
    name: 'ALL_TICKETS_LABEL'
  },
  {
    id:
      TICKETING_SYSTEM_CUSTOM_FILTER_KEY_MAPPER.UNASSIGNED_PRIOR_AUTHORIZATIONS,
    name: 'UNASSIGNED_TICKETS_LABEL'
  },
  {
    id: TICKETING_SYSTEM_CUSTOM_FILTER_KEY_MAPPER.UN_ATTENDED_TICKETS,
    name: 'UN_ATTENDED_TICKETS_LABEL'
  },
  {
    id: TICKETING_SYSTEM_CUSTOM_FILTER_KEY_MAPPER.CLOSED_TICKETS,
    name: 'CLOSED_TICKETS_LABEL'
  }
] as const;

export const TICKETING_SYSTEM_TICKET_ACTION_TYPES = {
  COMMENT: 'comment',
  CREATE_TICKET: 'create_ticket',
  UPDATE_TICKET: 'update_ticket',
  CREATE_TICKET_ATTACHMENT: 'create_ticket_attachment',
  HISTORY: 'history',
  WORK_LOG: 'work_log'
};

export const TICKETING_SYSTEM_UPDATED_TICKET_FILED = {
  TITLE: 'title',
  DESCRIPTION: 'description',
  STATUS: 'status',
  ASSIGNED_TO: 'assigned_to',
  PROVIDER: 'provider',
  PAYER: 'payer'
};

export const TICKET_ACTION_TYPE_TO_ACTIVITY_TYPE_MAPPER = {
  [TICKETING_SYSTEM_TICKET_ACTION_TYPES.COMMENT]:
    'TICKETING_SYSTEM.ACTIVITY.COMMENT',
  [TICKETING_SYSTEM_TICKET_ACTION_TYPES.CREATE_TICKET]:
    'TICKETING_SYSTEM.ACTIVITY.HISTORY',
  [TICKETING_SYSTEM_TICKET_ACTION_TYPES.UPDATE_TICKET]:
    'TICKETING_SYSTEM.ACTIVITY.HISTORY',
  [TICKETING_SYSTEM_TICKET_ACTION_TYPES.CREATE_TICKET_ATTACHMENT]:
    'TICKETING_SYSTEM.ACTIVITY.HISTORY',
  [TICKETING_SYSTEM_TICKET_ACTION_TYPES.HISTORY]:
    'TICKETING_SYSTEM.ACTIVITY.HISTORY',
  [TICKETING_SYSTEM_TICKET_ACTION_TYPES.WORK_LOG]:
    'TICKETING_SYSTEM.ACTIVITY.TIME_LOGS'
};

export const TICKETING_SYSTEM_ACTIVITY_TAB_VALUE = {
  COMMENTS: 'comment',
  ALL: 'all',
  HISTORY: 'history',
  TIME_LOGS: 'work_log'
};

export const TICKETING_SYSTEM_ACTIVITY_TABS = [
  {
    label: 'TICKETING_SYSTEM.ACTIVITY.ALL',
    value: TICKETING_SYSTEM_ACTIVITY_TAB_VALUE.ALL
  },
  {
    label: 'TICKETING_SYSTEM.ACTIVITY.COMMENTS',
    value: TICKETING_SYSTEM_ACTIVITY_TAB_VALUE.COMMENTS
  },
  {
    label: 'TICKETING_SYSTEM.ACTIVITY.HISTORY',
    value: TICKETING_SYSTEM_ACTIVITY_TAB_VALUE.HISTORY
  },
  {
    label: 'TICKETING_SYSTEM.ACTIVITY.TIME_LOGS',
    value: TICKETING_SYSTEM_ACTIVITY_TAB_VALUE.TIME_LOGS
  }
];

export const TICKETING_SYSTEM_COMMON_PERMISSIONS = {
  NAME: 'NAME',
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  READ: 'READ',
  LIST: 'LIST',
  DELETE: 'DELETE',
  STATUS_LIST: 'STATUS_LIST',
  CREATE_COMMENT: 'CREATE_COMMENT',
  EDIT_COMMENT: 'EDIT_COMMENT',
  ACTION_HISTORY_LIST: 'ACTION_HISTORY_LIST',
  DELETE_COMMENT: 'DELETE_COMMENT',
  CREATE_ATTACHMENT: 'CREATE_ATTACHMENT',
  READ_ATTACHMENT: 'READ_ATTACHMENT',
  DELETE_ATTACHMENT: 'DELETE_ATTACHMENT',
  CREATE_WORK_LOG: 'CREATE_WORK_LOG',
  CREATE_WORK_LOG_MANUALLY: 'CREATE_WORK_LOG_MANUALLY',
  LIST_WORK_LOG: 'LIST_WORK_LOG',
  DELETE_WORK_LOG: 'DELETE_WORK_LOG',
  DASHBOARD: 'DASHBOARD'
} as const;

export const TICKETING_SYSTEM_OPTIONAL_PERMISSIONS = {
  IMPORT_FILE: 'IMPORT_FILE'
} as const;

export const TICKETING_SYSTEM_MODULE_NAME_TO_MODULE_ID_MAPPER = {
  PRIOR_AUTHORIZATION: 'tms-prior-auth',
  CLAIMS_TICKETS: 'tms-claims',
  REFERRALS_TICKETS: 'tms-referrals'
} as const;

export const MESSAGES_EVENT_TYPE_MAPPER = {
  PRIOR_AUTHORIZATION: 'prior_auth_message',
  CLAIMS_TICKETS: 'claim_message',
  REFERRALS_TICKETS: 'referral_message'
};

export const FILTER_AGE_BY = [
  {
    label: '0-30 days',
    value: 'filter_by=age&min_age=0&max_age=30'
  },
  {
    label: '31-60 days',
    value: 'filter_by=age&min_age=31&max_age=60'
  },
  {
    label: '61-90 days',
    value: 'filter_by=age&min_age=61&max_age=90'
  },
  {
    label: 'Above 90 days',
    value: 'filter_by=age&min_age=91'
  }
];
export const TICKETING_SYSTEM_TABS = {
  DASHBOARD: 'DASHBOARD',
  GRID: 'GRID'
};

export const TICKETING_SYSTEM_SUMMARY_CHIPS_LABELS_MAPPER = {
  total_records:
    'TICKETING_SYSTEM.PREVIOUS_IMPORT_HISTORY_DRAWER.TOTAL_RECORDS_LABEL',
  saved_records:
    'TICKETING_SYSTEM.PREVIOUS_IMPORT_HISTORY_DRAWER.NEW_RECORDS_LABEL',
  updated_records:
    'TICKETING_SYSTEM.PREVIOUS_IMPORT_HISTORY_DRAWER.UPDATED_RECORDS_LABEL',
  duplicate_records:
    'TICKETING_SYSTEM.PREVIOUS_IMPORT_HISTORY_DRAWER.DUPLICATE_RECORDS_LABEL',
  failed_records:
    'TICKETING_SYSTEM.PREVIOUS_IMPORT_HISTORY_DRAWER.FAILED_RECORDS_LABEL'
};

export const TICKETING_SYSTEM_DASHBOARD_PARAMS = {
  BY_USER_DAY: 'by_user_day',
  BY_USER_WEEK: 'by_user_week',
  BY_USER_MONTH: 'by_user_month',
  BY_UNATTENDED_DAYS: 'by_unattended_days',
  BY_STATUS_PENDING: 'by_status_pending',
  BY_STATUS_COMPLETED: 'by_status_completed',
  BY_PRIORITY: 'by_priority'
};

export const CLAIMS_DASHBOARD_PARAMS = {
  BY_AGE: 'by_age',
  BY_AMOUNT: 'by_amount',
  THIS_MONTH: 'current_month',
  AVERAGE_PROCESSING_BY_PAYER: 'average_processing_by_payer',
  AVERAGE_PROCESSING_BY_AMOUNT: 'average_processing_by_amount'
};

export const TICKETING_SYSTEM_DASHBOARD_COLUMN_LABELS: {
  [key: string]: string;
} = {
  name: 'Name',
  count: 'Count',
  total_amount: 'Total Amount',
  days: 'Days',
  status: 'Status',
  date_of_service_min: 'From Date of Service',
  date_of_service_max: 'To Date of Service',
  priority: 'Priority',
  total: 'Total',
  worked: 'Worked'
};

export const PriorityOptionsList = [
  {
    label: 'High',
    value: 3
  },
  {
    label: 'Medium',
    value: 2
  },
  {
    label: 'Low',
    value: 1
  },
  {
    label: 'No Priority',
    value: 0
  }
];

export const DATE_RANGE_OPTIONS = [
  {
    label: 'Today',
    key: 'TODAY'
  },
  {
    label: 'Yesterday',
    key: 'YESTERDAY'
  },
  {
    label: 'This Week',
    key: 'THIS_WEEK'
  },
  {
    label: 'Last Week',
    key: 'LAST_WEEK'
  },
  {
    label: 'Past Two Weeks',
    key: 'PAST_TWO_WEEKS'
  },
  {
    label: 'This Month',
    key: 'THIS_MONTH'
  },
  {
    label: 'Last Month',
    key: 'LAST_MONTH'
  },
  {
    label: 'This Year',
    key: 'THIS_YEAR'
  },
  {
    label: 'Last Year',
    key: 'LAST_YEAR'
  }
];

// keys for the module mappers
export const moduleNameTransMapperByModuleId: {[key: string]: string} = {
  patients: 'TOP_NAV_COMMON.TABS.PATIENTS',
  appointments: 'TOP_NAV_COMMON.PATIENT_TAB.APPOINTMENTS',
  statements: 'TABS.PATIENT_STATEMENTS',
  payments: 'TOP_NAV_COMMON.INVOICES_TABS.PAYMENT_HISTORY',
  messages: 'TABS.INCOMING_SMS',
  patient_recalls: 'TOP_NAV_COMMON.TABS.PATIENT_RECALL',
  ccm: 'TOP_NAV_COMMON.TABS.CCM',
  prior_authorizations_tickets: 'TOP_NAV_COMMON.TABS.PRIOR_AUTHORIZATIONS',
  claims_tickets: 'TOP_NAV_COMMON.TABS.CLAIMS_TICKETS',
  referrals_tickets: 'TOP_NAV_COMMON.TABS.REFERRALS_TICKETS',
  patient_forms: 'TOP_NAV_COMMON.TABS.PATIENT_FORMS',
  claims: 'TOP_NAV_COMMON.TABS.CLAIMS'
};

export const SYSTEM_MODULE_FEATURES: {[key: string]: string} = {
  PATIENTS: 'patients',
  STATEMENTS: 'statements',
  CCM: 'ccm',
  CLAIM_TICKETS: 'claims_tickets',
  PRIOR_AUTHORIZATIONS: 'prior_authorizations_tickets',
  SMART_CODER: 'smart_coder'
};

export const SYSTEM_MODULE_FEATURE_VALUES: {[key: string]: string} = {
  PATIENTS_SHARED: 'patients_shared',
  EMR_PROVIDER: 'emr_provider',
  SPLIT_STATEMENT: 'split_statement',
  IS_MULTI_COLUMN_MAPPING: 'is_multi_column_mapping',
  SEND_FREQUENT_NOTIFICATION_GUARANTOR: 'send_frequent_notification_guarantor',
  CONSOLIDATED_GEOUP_BILLING: 'consolidated_group_billing',
  BILLING_CLINIC_ID: 'billing_clinic_id',
  SHOW_ONLY_BILLING_PRACTICE: 'show_only_billing_practice',
  CCM_CLINIC_ID: 'ccm_clinic_id',
  IS_CPT_CODES_ENABLED: 'is_claim_tickets_cpt_codes_enabled',
  AUTO_CREATE_PRIOR_AUTH_ON_APPOINTMENT_IMPORT:
    'auto_create_prior_auth_on_appointment_import',
  IS_DOCTOR_NOTES_ANALYSIS_ENABLED: 'is_doctor_notes_analysis_enabled',
  ENABLE_ADD_PATIENTS: 'enable_add_patients',
  ENABLE_EDIT_PATIENTS: 'enable_edit_patients',
  SEND_PATIENTS_TO_EMR: 'send_patients_to_emr'
};
// creating below mapper to define the names using the module_id's here
export const moduleNameMapper: {[key: string]: string} = {
  patients: AppPermissions.PATIENT.NAME,
  appointments: AppPermissions.APPOINTMENT.NAME,
  statements: AppPermissions.STATEMENT.NAME,
  payments: AppPermissions.PAYMENT_HISTORY.NAME,
  messages: AppPermissions.INCOMING_SMS.NAME,
  patient_recalls: AppPermissions.PATIENT_RECALL.NAME,
  ccm: AppPermissions.CCM.NAME,
  prior_authorizations_tickets: AppPermissions.PRIOR_AUTHORIZATION.NAME,
  claims_tickets: AppPermissions.CLAIMS_TICKETS.NAME,
  referrals_tickets: AppPermissions.REFERRALS_TICKETS.NAME,
  patient_forms: AppPermissions.PATIENT_FORMS.NAME,
  claims: AppPermissions.CLAIM.NAME
};

export const MENUOPTIONS = {
  DASHBOARD: 'DASHBOARD',
  CLINICS: 'CLINICS'
};

export const APPOINTMENT_TYPES = {
  VACCINE: 'vaccine'
};

export const APPOINTMENT_TYPE_TRANS_KEY = {
  [APPOINTMENT_TYPES.VACCINE]:
    'CLINICS.APPOINTMENT_SLOTS.APPOINTMENT_TYPE.VACCINE'
};

export const PatientFormFilterStatus = [
  {
    label: 'Sent',
    value: 'sent'
  },
  {
    label: 'Submitted',
    value: 'submitted'
  },
  {
    label: 'Downloaded',
    value: 'downloaded'
  }
];

export const PatientFormMapStatus = {
  SENT: 'sent',
  SUBMITTED: 'submitted',
  DOWNLOADED: 'downloaded'
};

// export const ClaimStatusTypes = [
//   {
//     id: 'all',
//     value: 'All'
//   },
//   {
//     id: 'pending',
//     value: 'Pending'
//   },
//   {
//     id: 'approved',
//     value: 'Approved'
//   },
//   {
//     id: 'paid',
//     value: 'Paid'
//   },
//   {
//     id: 'rejected',
//     value: 'Rejected'
//   },
//   {
//     id: 'ignored',
//     value: "Ignored"
//   }
// ];

export const PharmacyClaimStatus = {
  PENDING: 'pending',
  /** Aggregate: incomplete data, missing insurance, pending submission, failed — used by Attention tab */
  ATTENTION: 'attention',
  /** Claim exists but cannot be submitted until patient/appointment data is fixed */
  INCOMPLETE_DATA: 'incomplete_data',
  REJECTED: 'rejected',
  PAID: 'paid',
  FAILED: 'failed',
  MISSING_INSURANCE: 'missing_insurance',
  DUPLICATED: 'duplicated',
  REVERSED: 'reversed',
  IGNORED: 'ignored',
  CLOSED: 'closed',
  ADJUSTED_AND_CLOSED: 'adjusted_and_closed',
  ADDED_TO_PATIENT_BALANCE: 'added_to_patient_balance',
  ADJUST_PATIENT_BALANCE: 'adjust_patient_balance'
};

export const ClaimDasboardStatusTypes = [
  {
    label: 'All',
    value: 'all'
  },
  {
    label: 'Needs attention (all)',
    value: PharmacyClaimStatus.ATTENTION
  },
  {
    label: 'Pending Submission',
    value: PharmacyClaimStatus.PENDING
  },
  {
    label: 'Incomplete data',
    value: PharmacyClaimStatus.INCOMPLETE_DATA
  },
  {
    label: 'Rejected',
    value: PharmacyClaimStatus.REJECTED
  },
  {
    label: 'Paid',
    value: PharmacyClaimStatus.PAID
  },
  {
    label: 'Failed',
    value: PharmacyClaimStatus.FAILED
  },
  {
    label: 'Missing Insurance',
    value: PharmacyClaimStatus.MISSING_INSURANCE
  },
  {
    label: 'Duplicated',
    value: PharmacyClaimStatus.DUPLICATED
  },
  {
    label: 'Reversed',
    value: PharmacyClaimStatus.REVERSED
  },
  {
    label: 'Ignored',
    value: PharmacyClaimStatus.IGNORED
  },
  {
    label: 'Closed',
    value: PharmacyClaimStatus.CLOSED
  },
  {
    label: 'Adjusted and Closed',
    value: PharmacyClaimStatus.ADJUSTED_AND_CLOSED
  },
  {
    label: 'Added to Patient Balance',
    value: PharmacyClaimStatus.ADDED_TO_PATIENT_BALANCE
  },
  {
    label: 'Adjusted Patient Balance',
    value: PharmacyClaimStatus.ADJUST_PATIENT_BALANCE
  }
];

// Statuses eligible for Send Claim action
export const SendClaimEligibleStatuses = [
  PharmacyClaimStatus.PENDING,
  PharmacyClaimStatus.MISSING_INSURANCE,
  PharmacyClaimStatus.FAILED
];

export const SYSTEM_MODULES = {
  PRIOR_AUTHORIZATIONS: 'prior_authorizations'
};

export const InsuranceTypes = [
  {
    name: 'ELIGIBILITY_VERIFICATION.REGULAR_INSURANCE',
    value: 'regular_insurance'
  },
  {
    name: 'ELIGIBILITY_VERIFICATION.PHARMACY_BENEFIT_CARD',
    value: 'pharmacy_benefit_card'
  }
];

export const UPDATED_TICKET_DETAILS_TEXT = 'Updated this ticket details';

export const PRIOR_AUTH_ADDITIONAL_FIELDS = {
  AUTHORIZATION_ID: 'authorization_id',
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  ADDITIONAL_INFO_NOTES: 'additional_info_notes',
  APPROVED_CODES: 'approved_codes',
  DENIED_CODES: 'denied_codes'
};

export const PROCEDURE_FIELD_TYPE = {
  SELECT: 'select',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  NUMBER: 'number'
};

export const PROCEDURE_FIELD_OPTION_SOURCE = {
  STATIC: 'static'
};

export const SMART_CODER_RELATED_TYPES = {
  PRIOR_AUTHORIZATIONS: 'prior_authorizations_tickets'
};

export const SMART_CODER_PROCEDURE_TYPES = {
  PAIN_MED_PROCEDURE: 'pain_medication',
  SEDATION: 'sedation'
};

export const GENERATE_CPT_CODE_TAB_ID = {
  PROCEDURE: 'PROCEDURE',
  'SEDATION/ANESTHESIA': 'SEDATION/ANESTHESIA',
  HCPCS: 'HCPCS',
  PROCESSING_TIMES: 'PROCESSING_TIMES'
};

export const EMR_ADAPTER_TYPE = {
  NEXHEALTH: 'nexhealth',
  RPA: 'rpa',
  ECW: 'ecw',
  VERADIGM_UNITY: 'veradigm_unity',
  EPIC_FHIR: 'epic_fhir',
  MANUAL: 'manual'
};

export const EMR_LIST = [
  {
    label: 'ECW',
    value: 1
  },
  {label: 'OFFICE ALLY AND PRACTICE_MATE', value: 2},
  {label: 'CENTRICITY', value: 3},
  {label: 'ALL SCRIPT', value: 4},
  {label: 'ALL SCRIPT V2', value: 5},
  {label: 'MODMED', value: 6},
  {label: 'EPIC', value: 7},
  {label: 'CureMD', value: 8},
  {label: 'NEXTGEN', value: 9},
  {label: 'Generic', value: 10},
  {label: 'AdvancedMD', value: 11},
  {label: 'Medent', value: 12}
];

export const FILE_LIST = [
  {
    label: 'Patient',
    value: 'patient'
  },
  {label: 'Appointment', value: 'appointment'}
];
export const CASH_PAYMENT = 'CASH';

export const JOB_TITLE_KEY = 'job-titles';

export const EMR_PAYLOAD_STATUS = [
  {
    label: 'Processed',
    value: 'processed'
  },
  {label: 'Received', value: 'received'},
  {label: 'Failed', value: 'failed'}
];

export const EMR_PAYLOAD_MESSAGE_TYPE = [
  {
    label: 'SIU',
    value: 'SIU'
  },
  {label: 'ADT', value: 'ADT'}
];

export const EMR_SEARCH_ATTRIBUTES = {
  ERROR_MESSAGE: 'Error Message'
};

export const PATIENT_GENDER_LIST = [
  {label: 'Male', value: 'M'},
  {label: 'Female', value: 'F'},
  {label: 'Other', value: 'Other'}
];

export const PROVIDER_GENDER_LIST = [
  {label: 'Male', value: 'male'},
  {label: 'Female', value: 'female'},
  {label: 'Other', value: 'other'}
];

// Which part of a provider's name pre-fills their spoken name for the voice agent.
export const PROVIDER_SPOKEN_NAME_SOURCES = {
  LAST_NAME: 'last_name',
  FIRST_NAME: 'first_name',
  FULL_NAME: 'full_name'
};

export const PROVIDER_SPOKEN_NAME_SOURCE_LIST = [
  {label: 'Last name', value: PROVIDER_SPOKEN_NAME_SOURCES.LAST_NAME},
  {label: 'First name', value: PROVIDER_SPOKEN_NAME_SOURCES.FIRST_NAME},
  {label: 'Full name', value: PROVIDER_SPOKEN_NAME_SOURCES.FULL_NAME}
];

// Matches the varchar(255) column on OrgGroupHealthCareProvider.
export const SPOKEN_NAME_MAX_LENGTH = 255;

// Mirrors SPOKEN_NAME_PLACEHOLDER in server/common/mappings.js: the token an admin
// writes in a role spoken form to place the provider's name.
export const SPOKEN_NAME_PLACEHOLDER = '<spoken_name>';

export const PatientTypes = {
  IMPORTED: 'imported',
  CREATED_BY_ADMIN: 'created by admin',
  CREATED_BY_VOICE_ASSISTANCE: 'created by voice assistant',
  CREATED_FOR_PAYMENT: 'created for payment',
  NEW_PUBLIC_PAYMENT: 'public payment'
};
